(function () {
  'use strict';

  var existing = window.SCProductConfigurator;
  if (existing && existing.__engine) {
    existing.initAll(document);
    return;
  }

  var VERSION = '1.0.0';
  var slice = Array.prototype.slice;
  var hasOwn = Object.prototype.hasOwnProperty;
  var bodyLocks = 0;
  var savedBodyOverflow = '';

  function list(nodes) { return slice.call(nodes || []); }
  function text(value) { return value == null ? '' : String(value); }
  function integer(value, fallback) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) ? parsed : (fallback || 0);
  }
  function cents(value) { return Math.max(0, integer(value, 0)); }
  function bool(value, fallback) {
    return value == null ? fallback : value === true || value === 'true' || value === 1 || value === '1';
  }
  function copyObject(source) {
    var output = {};
    Object.keys(source || {}).forEach(function (key) {
      output[key] = Array.isArray(source[key]) ? source[key].slice() : source[key];
    });
    return output;
  }
  function unique(values) {
    var seen = {};
    return (values || []).filter(function (value) {
      var key = text(value);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }
  function normalToken(value) {
    return text(value).trim().replace(/\s*=\s*/g, '=').replace(/\s+/g, ' ').toLowerCase();
  }
  function normalizeSignature(value) {
    var tokens = Array.isArray(value) ? value : text(value).split(/[|,\n]+/);
    return unique(tokens.map(normalToken).filter(Boolean)).sort().join('|');
  }
  function sameValue(left, right) { return normalToken(left) === normalToken(right); }
  function validVariant(value) { return value != null && text(value) !== '' && text(value) !== '0'; }
  function safeHref(value) {
    var href = text(value).trim();
    if (!href) return '';
    if (/^(https?:|mailto:|tel:)/i.test(href)) return href;
    if (href.charAt(0) === '#' || (href.charAt(0) === '/' && href.charAt(1) !== '/')) return href;
    return '';
  }
  function matches(element, selector) {
    var fn = element && (element.matches || element.msMatchesSelector || element.webkitMatchesSelector);
    return !!(fn && fn.call(element, selector));
  }
  function closest(element, selector, boundary) {
    var node = element && element.nodeType === 3 ? element.parentElement : element;
    while (node && node !== boundary && node.nodeType === 1) {
      if (matches(node, selector)) return node;
      node = node.parentElement;
    }
    return node === boundary && matches(node, selector) ? node : null;
  }
  function clear(element) {
    if (!element) return;
    while (element.firstChild) element.removeChild(element.firstChild);
  }
  function eventOf(name, detail) {
    try { return new CustomEvent(name, { bubbles: true, composed: true, detail: detail }); }
    catch (error) {
      var event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, false, detail);
      return event;
    }
  }
  function dispatch(target, name, detail) { target.dispatchEvent(eventOf(name, detail)); }
  function lockBody() {
    if (bodyLocks === 0 && document.body) {
      savedBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    bodyLocks += 1;
  }
  function unlockBody() {
    bodyLocks = Math.max(0, bodyLocks - 1);
    if (bodyLocks === 0 && document.body) document.body.style.overflow = savedBodyOverflow;
  }
  function pauseVideos(scope) {
    list(scope && scope.querySelectorAll ? scope.querySelectorAll('video') : []).forEach(function (video) {
      try { video.pause(); } catch (error) { /* A detached video can reject pause in old WebKit. */ }
    });
  }
  function setElementHidden(element, hidden) {
    if (!element) return;
    element.hidden = !!hidden;
    element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }
  function attributeKey(element, attribute) {
    var value = element ? element.getAttribute(attribute) : '';
    if (value) return value;
    var child = element && element.querySelector ? element.querySelector('[' + attribute + ']') : null;
    return child ? child.getAttribute(attribute) : '';
  }

  function Configurator(root) {
    this.root = root;
    root.__scpcInstance = this;
    this.destroyed = false;
    this.cleanups = [];
    this.issues = [];
    this.hasFatalConfig = false;
    this.adding = false;
    this.modalItem = null;
    this.modalFocus = null;
    this.modalOpen = false;
    this.expanded = false;
    this.expandFocus = null;
    this.reviewOpen = false;
    this.reviewFocus = null;
    this.barFloating = false;
    this.barSpacer = null;
    this.initialEvent = true;
    this.lastLegacyValue = null;
    this.lastChangedKey = '';
    this.lastChoiceId = '';
    this.cartMessage = '';
    var scpcAddSpan = root.querySelector('[data-scpc-add] span');
    this.addLabelComplete = scpcAddSpan ? text(scpcAddSpan.textContent).trim() : 'Add my build';
    this.mediaFrame = 0;
    this.modalMediaFrame = 0;
    this.modalMediaIndex = 0;
    this.currentMediaKey = '';
    var initialMediaRoot = root.querySelector('[data-scpc-media-root]');
    this.initialMediaNodes = initialMediaRoot ? list(initialMediaRoot.childNodes).map(function (node) { return node.cloneNode(true); }) : [];
    this.initialContextTitle = text(root.querySelector('[data-scpc-context-title]') && root.querySelector('[data-scpc-context-title]').textContent).trim();
    this.initialContextSummary = text(root.querySelector('[data-scpc-context-summary]') && root.querySelector('[data-scpc-context-summary]').textContent).trim();
    this.recommended = null;
    this.matcherData = { breeds: [], species: {}, aliases: {}, seen: {} };
    this.config = this.readConfig();
    if (!this.config) { root.__scpcInstance = null; return; }
    this.normaliseConfig();
    this.indexConfig();
    this.state = { selections: {}, quantities: {}, openStep: '' };
    this.seedDefaults();
    this.restore();
    this.stabiliseState();
    this.bind();
    this.validate();
    this.selectInitialStep();
    this.selectInitialMedia();
    this.update('');
    this.loadMatcher();
    root.setAttribute('data-scpc-initialized', 'true');
  }

  Configurator.prototype.readConfig = function () {
    var script = this.root.querySelector('script[data-scpc-config], script[type="application/json"][data-scpc-config]');
    if (!script) {
      this.runtimeIssue('Missing the configurator JSON script.');
      return null;
    }
    try { return JSON.parse(script.textContent || '{}'); }
    catch (error) {
      this.runtimeIssue('The configurator JSON could not be parsed: ' + error.message);
      return null;
    }
  };

  Configurator.prototype.normaliseConfig = function () {
    var cfg = this.config;
    cfg.sectionId = text(cfg.sectionId);
    cfg.builderKey = text(cfg.builderKey || cfg.sectionId || 'builder');
    cfg.currency = text(cfg.currency || 'AUD').toUpperCase();
    cfg.locale = text(cfg.locale || document.documentElement.lang || 'en-AU');
    cfg.cartAddUrl = text(cfg.cartAddUrl || '/cart/add.js');
    cfg.cartUrl = text(cfg.cartUrl || '/cart');
    cfg.cartAction = /^(drawer|cart|stay)$/.test(cfg.cartAction) ? cfg.cartAction : 'drawer';
    cfg.fallbackMode = /^(individual|disable|hide)$/.test(cfg.fallbackMode) ? cfg.fallbackMode : 'individual';
    cfg.autoAdvance = bool(cfg.autoAdvance, true);
    cfg.requireComplete = bool(cfg.requireComplete, true);
    cfg.persist = bool(cfg.persist, false);
    cfg.connectedValueKey = text(cfg.connectedValueKey);
    cfg.legacyEvent = cfg.legacyEvent == null ? false : cfg.legacyEvent;
    cfg.steps = Array.isArray(cfg.steps) ? cfg.steps : [];
    cfg.options = Array.isArray(cfg.options) ? cfg.options : [];
    cfg.quantities = Array.isArray(cfg.quantities) ? cfg.quantities : [];
    cfg.rules = Array.isArray(cfg.rules) ? cfg.rules : [];
    cfg.bundles = Array.isArray(cfg.bundles) ? cfg.bundles : [];
    cfg.matcher = cfg.matcher && typeof cfg.matcher === 'object' ? cfg.matcher : {};
    cfg.strings = cfg.strings && typeof cfg.strings === 'object' ? cfg.strings : {};
    cfg.strings.included = text(cfg.strings.included || 'Included');
    cfg.strings.noChange = text(cfg.strings.noChange || 'No change');
    cfg.strings.unavailable = text(cfg.strings.unavailable || 'Unavailable');
    cfg.strings.selectRequired = text(cfg.strings.selectRequired || 'Please complete the required choices.');
    cfg.strings.adding = text(cfg.strings.adding || 'Adding your build…');
    cfg.strings.added = text(cfg.strings.added || 'Your build was added.');
    cfg.strings.error = text(cfg.strings.error || 'We could not add this build. Please try again.');
    cfg.strings.bundle = text(cfg.strings.bundle || 'Bundle');
    cfg.strings.extra = text(cfg.strings.extra || 'Extra');
    cfg.strings.referenceTotal = text(cfg.strings.referenceTotal || 'Regular price');
    cfg.strings.savings = text(cfg.strings.savings || 'You save');

    cfg.steps.forEach(function (step) {
      step.key = text(step.key).trim();
      step.label = text(step.label || step.key);
      step.subheading = text(step.subheading);
      step.type = step.type === 'multiple' ? 'multiple' : (step.type === 'quantity' ? 'quantity' : 'single');
      step.required = bool(step.required, false);
      step.open = bool(step.open, false);
      step.autoAdvance = bool(step.autoAdvance, cfg.autoAdvance);
    });
    cfg.options.forEach(function (option, index) {
      option.id = text(option.id || ('option-' + index)).trim();
      option.stepKey = text(option.stepKey).trim();
      option.value = text(option.value || option.id).trim();
      option.label = text(option.label || option.value);
      option.subtext = text(option.subtext);
      option.badge = text(option.badge);
      option.variantId = text(option.variantId);
      option.variantSkuRequested = text(option.variantSkuRequested).trim();
      option.variantSkuMatches = Math.max(0, integer(option.variantSkuMatches, 0));
      option.productVariantCount = Math.max(0, integer(option.productVariantCount, 0));
      option.price = cents(option.price);
      option.compareAt = cents(option.compareAt);
      option.available = bool(option.available, true);
      option.variantSkuInvalid = !!option.variantSkuRequested && option.variantSkuMatches !== 1;
      if (option.variantSkuInvalid) { option.variantId = ''; option.available = false; }
      option.includeInSignature = bool(option.includeInSignature, false);
      option.bundleToken = text(option.bundleToken).trim();
      option.addSeparately = bool(option.addSeparately, false);
      option.noFallbackProduct = bool(option.noFallbackProduct, false);
      option.defaultSelected = bool(option.defaultSelected, false);
      option.changesMedia = bool(option.changesMedia, false);
      option.tooltipHtml = text(option.tooltipHtml);
      option.mediaKey = text(option.mediaKey);
      option.condition = option.condition && typeof option.condition === 'object' ? option.condition : null;
      if (option.condition) {
        option.condition.key = text(option.condition.key).trim();
        option.condition.operator = text(option.condition.operator || 'equals').toLowerCase();
      }
    });
    cfg.quantities.forEach(function (quantity, index) {
      quantity.id = text(quantity.id || quantity.key || ('quantity-' + index)).trim();
      quantity.stepKey = text(quantity.stepKey).trim();
      quantity.key = text(quantity.key || quantity.id).trim();
      quantity.label = text(quantity.label || quantity.key);
      quantity.subtext = text(quantity.subtext);
      quantity.variantId = text(quantity.variantId);
      quantity.variantSkuRequested = text(quantity.variantSkuRequested).trim();
      quantity.variantSkuMatches = Math.max(0, integer(quantity.variantSkuMatches, 0));
      quantity.productVariantCount = Math.max(0, integer(quantity.productVariantCount, 0));
      quantity.price = cents(quantity.price);
      quantity.compareAt = cents(quantity.compareAt);
      quantity.available = bool(quantity.available, true);
      quantity.variantSkuInvalid = !!quantity.variantSkuRequested && quantity.variantSkuMatches !== 1;
      if (quantity.variantSkuInvalid) { quantity.variantId = ''; quantity.available = false; }
      quantity.min = Math.max(0, integer(quantity.min, 1));
      quantity.max = Math.max(quantity.min, integer(quantity.max, 20));
      quantity.defaultQuantity = Math.max(0, integer(quantity.defaultQuantity, 0));
      quantity.relatedKey = text(quantity.relatedKey);
      quantity.relatedValue = quantity.relatedValue == null ? '' : quantity.relatedValue;
      quantity.tooltipHtml = text(quantity.tooltipHtml);
      quantity.mediaKey = text(quantity.mediaKey);
      quantity.changesMedia = bool(quantity.changesMedia, false);
    });
    cfg.rules.forEach(function (rule) {
      rule.whenKey = text(rule.whenKey);
      rule.operator = text(rule.operator || 'equals').toLowerCase();
      rule.targetType = text(rule.targetType || 'option').toLowerCase();
      rule.targetKey = text(rule.targetKey);
      rule.action = text(rule.action || 'show').toLowerCase();
    });
    cfg.bundles.forEach(function (bundle) {
      bundle.productId = text(bundle.productId);
      bundle.variantId = text(bundle.variantId);
      bundle.title = text(bundle.title || 'Bundle');
      bundle.signature = normalizeSignature(bundle.signature);
      bundle.priority = integer(bundle.priority, 0);
      bundle.price = cents(bundle.price);
      bundle.compareAt = cents(bundle.compareAt);
      bundle.available = bool(bundle.available, true);
    });

    cfg.matcher.enabled = bool(cfg.matcher.enabled, false);
    cfg.matcher.speciesUrl = text(cfg.matcher.speciesUrl);
    cfg.matcher.aliasesUrl = text(cfg.matcher.aliasesUrl);
    cfg.matcher.targetStep = text(cfg.matcher.targetStep);
    cfg.matcher.autoSelect = bool(cfg.matcher.autoSelect, true);
    cfg.matcher.beforeSpecies = cfg.matcher.beforeSpecies == null ? 'Recommended for' : text(cfg.matcher.beforeSpecies);
    cfg.matcher.afterSpecies = text(cfg.matcher.afterSpecies);
    cfg.matcher.fitLabel = cfg.matcher.fitLabel == null ? 'Recommended fit' : text(cfg.matcher.fitLabel);
    cfg.matcher.smallReason = text(cfg.matcher.smallReason);
    cfg.matcher.largeReason = text(cfg.matcher.largeReason);
    cfg.matcher.borderlineText = text(cfg.matcher.borderlineText);
    cfg.matcher.secondOpinionText = text(cfg.matcher.secondOpinionText);
    cfg.matcher.teamLinkLabel = text(cfg.matcher.teamLinkLabel);
    cfg.matcher.teamLinkUrl = safeHref(cfg.matcher.teamLinkUrl);
    cfg.matcher.unknownText = cfg.matcher.unknownText == null ? 'We could not find that species. Please choose the best fit or ask our team.' : text(cfg.matcher.unknownText);
  };

  Configurator.prototype.indexConfig = function () {
    var self = this;
    this.stepsByKey = {};
    this.optionsById = {};
    this.optionsByStep = {};
    this.quantitiesById = {};
    this.quantitiesByKey = {};
    this.quantitiesByStep = {};
    this.config.steps.forEach(function (step) { self.stepsByKey[step.key] = step; });
    this.config.options.forEach(function (option) {
      self.optionsById[option.id] = option;
      (self.optionsByStep[option.stepKey] || (self.optionsByStep[option.stepKey] = [])).push(option);
    });
    this.config.quantities.forEach(function (quantity) {
      self.quantitiesById[quantity.id] = quantity;
      self.quantitiesByKey[quantity.key] = quantity;
      (self.quantitiesByStep[quantity.stepKey] || (self.quantitiesByStep[quantity.stepKey] = [])).push(quantity);
    });
  };

  Configurator.prototype.seedDefaults = function () {
    var self = this;
    this.config.steps.forEach(function (step) { self.state.selections[step.key] = step.type === 'multiple' ? [] : ''; });
    this.config.options.forEach(function (option) {
      if (!option.defaultSelected) return;
      var step = self.stepsByKey[option.stepKey];
      if (!step) return;
      if (step.type === 'multiple') {
        if (self.state.selections[step.key].indexOf(option.value) < 0) self.state.selections[step.key].push(option.value);
      } else if (!self.state.selections[step.key]) self.state.selections[step.key] = option.value;
    });
    this.config.quantities.forEach(function (quantity) {
      self.state.quantities[quantity.key] = self.clampQuantity(quantity, quantity.defaultQuantity);
    });
  };

  Configurator.prototype.storageKey = function () { return 'scpc:' + this.config.builderKey; };
  Configurator.prototype.restore = function () {
    if (!this.config.persist || !window.sessionStorage) return;
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(this.storageKey()) || 'null'); }
    catch (error) { saved = null; }
    if (!saved || typeof saved !== 'object') return;
    var self = this;
    Object.keys(saved.selections || {}).forEach(function (stepKey) {
      var step = self.stepsByKey[stepKey];
      if (!step) return;
      var allowed = (self.optionsByStep[stepKey] || []).map(function (option) { return option.value; });
      if (step.type === 'multiple') {
        self.state.selections[stepKey] = unique(Array.isArray(saved.selections[stepKey]) ? saved.selections[stepKey] : []).filter(function (value) { return allowed.indexOf(value) >= 0; });
      } else if (allowed.indexOf(saved.selections[stepKey]) >= 0) self.state.selections[stepKey] = saved.selections[stepKey];
    });
    Object.keys(saved.quantities || {}).forEach(function (key) {
      var quantity = self.quantitiesByKey[key];
      if (quantity) self.state.quantities[key] = self.clampQuantity(quantity, saved.quantities[key]);
    });
  };
  Configurator.prototype.persist = function () {
    if (!this.config.persist || !window.sessionStorage) return;
    try { sessionStorage.setItem(this.storageKey(), JSON.stringify({ selections: this.state.selections, quantities: this.state.quantities })); }
    catch (error) { /* Storage may be unavailable in privacy mode. */ }
  };

  Configurator.prototype.clampQuantity = function (item, value) {
    var quantity = Math.max(0, integer(value, 0));
    if (quantity === 0) return 0;
    return Math.min(item.max, Math.max(item.min || 1, quantity));
  };
  Configurator.prototype.valueFor = function (key, selections, quantities) {
    if (hasOwn.call(selections, key)) return selections[key];
    if (hasOwn.call(quantities, key)) return quantities[key];
    var option = this.optionsById[key];
    if (option) return this.optionSelected(option, selections);
    var quantity = this.quantitiesById[key];
    if (quantity) return quantities[quantity.key] || 0;
    return '';
  };
  Configurator.prototype.compare = function (actual, operator, expected) {
    var values = Array.isArray(actual) ? actual : [actual];
    var equals = values.some(function (value) { return sameValue(value, expected); });
    var numericActual = parseFloat(Array.isArray(actual) ? actual[0] : actual);
    var numericExpected = parseFloat(expected);
    switch (text(operator).toLowerCase()) {
      case '!=': case 'not': case 'not_equals': case 'not-equals': return !equals;
      case 'contains': case 'includes': return values.some(function (value) { return normalToken(value).indexOf(normalToken(expected)) >= 0; });
      case 'not_contains': case 'not-includes': return !values.some(function (value) { return normalToken(value).indexOf(normalToken(expected)) >= 0; });
      case 'selected': case 'truthy': return Array.isArray(actual) ? actual.length > 0 : !!actual;
      case 'not_selected': case 'not-selected': case 'falsy': return Array.isArray(actual) ? actual.length === 0 : !actual;
      case '>': case 'gt': return isFinite(numericActual) && numericActual > numericExpected;
      case '>=': case 'gte': return isFinite(numericActual) && numericActual >= numericExpected;
      case '<': case 'lt': return isFinite(numericActual) && numericActual < numericExpected;
      case '<=': case 'lte': return isFinite(numericActual) && numericActual <= numericExpected;
      default: return equals;
    }
  };
  Configurator.prototype.conditionPasses = function (condition, selections, quantities) {
    if (!condition || !condition.key) return true;
    return this.compare(this.valueFor(condition.key, selections, quantities), condition.operator || 'equals', condition.value);
  };
  Configurator.prototype.rulePasses = function (rule, selections, quantities) {
    return this.compare(this.valueFor(rule.whenKey, selections, quantities), rule.operator, rule.value);
  };
  Configurator.prototype.optionSelected = function (option, selections) {
    var value = selections[option.stepKey];
    return Array.isArray(value) ? value.indexOf(option.value) >= 0 : value === option.value;
  };
  Configurator.prototype.targetOptions = function (targetKey) {
    return this.config.options.filter(function (option) {
      return option.id === targetKey || option.value === targetKey || (option.stepKey + '.' + option.value) === targetKey || (option.stepKey + '-' + option.value) === targetKey;
    });
  };
  Configurator.prototype.targetQuantities = function (targetKey) {
    return this.config.quantities.filter(function (quantity) { return quantity.id === targetKey || quantity.key === targetKey; });
  };

  Configurator.prototype.deriveEffects = function (selections, quantities) {
    var self = this;
    var effects = { hiddenSteps: {}, disabledSteps: {}, hiddenOptions: {}, disabledOptions: {}, hiddenQuantities: {}, disabledQuantities: {} };
    this.config.options.forEach(function (option) {
      if (!self.conditionPasses(option.condition, selections, quantities)) effects.hiddenOptions[option.id] = true;
    });
    this.config.quantities.forEach(function (quantity) {
      if (quantity.relatedKey && !self.compare(self.valueFor(quantity.relatedKey, selections, quantities), 'equals', quantity.relatedValue)) effects.hiddenQuantities[quantity.id] = true;
    });
    this.config.rules.forEach(function (rule) {
      var passes = self.rulePasses(rule, selections, quantities);
      var controlsVisibility = rule.action === 'hide' || rule.action === 'show';
      var controlsAvailability = rule.action === 'disable' || rule.action === 'enable';
      var hidden = rule.action === 'hide' ? passes : (rule.action === 'show' ? !passes : false);
      var disabled = rule.action === 'disable' ? passes : (rule.action === 'enable' ? !passes : false);
      if (!controlsVisibility && !controlsAvailability) return;
      if (rule.targetType === 'step') {
        if (controlsVisibility) effects.hiddenSteps[rule.targetKey] = !!effects.hiddenSteps[rule.targetKey] || hidden;
        if (controlsAvailability) effects.disabledSteps[rule.targetKey] = !!effects.disabledSteps[rule.targetKey] || disabled;
      } else if (rule.targetType === 'quantity') {
        self.targetQuantities(rule.targetKey).forEach(function (quantity) {
          if (controlsVisibility) effects.hiddenQuantities[quantity.id] = !!effects.hiddenQuantities[quantity.id] || hidden;
          if (controlsAvailability) effects.disabledQuantities[quantity.id] = !!effects.disabledQuantities[quantity.id] || disabled;
        });
      } else {
        self.targetOptions(rule.targetKey).forEach(function (option) {
          if (controlsVisibility) effects.hiddenOptions[option.id] = !!effects.hiddenOptions[option.id] || hidden;
          if (controlsAvailability) effects.disabledOptions[option.id] = !!effects.disabledOptions[option.id] || disabled;
        });
      }
    });
    return effects;
  };

  Configurator.prototype.setOptionState = function (option, selected, selections) {
    var step = this.stepsByKey[option.stepKey];
    if (!step) return false;
    var changed = false;
    if (step.type === 'multiple') {
      var values = Array.isArray(selections[step.key]) ? selections[step.key].slice() : [];
      var position = values.indexOf(option.value);
      if (selected && position < 0) { values.push(option.value); changed = true; }
      if (!selected && position >= 0) { values.splice(position, 1); changed = true; }
      selections[step.key] = unique(values);
    } else {
      var next = selected ? option.value : '';
      if (selections[step.key] !== next) { selections[step.key] = next; changed = true; }
    }
    return changed;
  };

  Configurator.prototype.stabiliseState = function () {
    var self = this;
    var loops = 0;
    var changed = true;
    while (changed && loops < 10) {
      changed = false;
      loops += 1;
      this.config.rules.forEach(function (rule) {
        if (!self.rulePasses(rule, self.state.selections, self.state.quantities)) return;
        if (rule.action !== 'select' && rule.action !== 'clear') return;
        var select = rule.action === 'select';
        if (rule.targetType === 'step' && !select) {
          var step = self.stepsByKey[rule.targetKey];
          if (step) {
            var empty = step.type === 'multiple' ? [] : '';
            if (JSON.stringify(self.state.selections[step.key]) !== JSON.stringify(empty)) { self.state.selections[step.key] = empty; changed = true; }
            (self.quantitiesByStep[step.key] || []).forEach(function (quantity) {
              if (self.state.quantities[quantity.key]) { self.state.quantities[quantity.key] = 0; changed = true; }
            });
          }
        } else if (rule.targetType === 'quantity') {
          self.targetQuantities(rule.targetKey).forEach(function (quantity) {
            var next = select ? Math.max(1, quantity.min) : 0;
            if (self.state.quantities[quantity.key] !== next) { self.state.quantities[quantity.key] = next; changed = true; }
          });
        } else {
          self.targetOptions(rule.targetKey).forEach(function (option) {
            if (self.setOptionState(option, select, self.state.selections)) changed = true;
          });
        }
      });
      var effects = this.deriveEffects(this.state.selections, this.state.quantities);
      this.config.steps.forEach(function (step) {
        if (!effects.hiddenSteps[step.key] && !effects.disabledSteps[step.key]) return;
        var empty = step.type === 'multiple' ? [] : '';
        if (JSON.stringify(self.state.selections[step.key]) !== JSON.stringify(empty)) { self.state.selections[step.key] = empty; changed = true; }
        (self.quantitiesByStep[step.key] || []).forEach(function (quantity) {
          if (self.state.quantities[quantity.key]) { self.state.quantities[quantity.key] = 0; changed = true; }
        });
      });
      this.config.options.forEach(function (option) {
        if ((effects.hiddenOptions[option.id] || effects.disabledOptions[option.id] || effects.disabledSteps[option.stepKey]) && self.optionSelected(option, self.state.selections)) {
          if (self.setOptionState(option, false, self.state.selections)) changed = true;
        }
      });
      this.config.quantities.forEach(function (quantity) {
        if ((effects.hiddenQuantities[quantity.id] || effects.disabledQuantities[quantity.id] || effects.disabledSteps[quantity.stepKey]) && self.state.quantities[quantity.key]) {
          self.state.quantities[quantity.key] = 0;
          changed = true;
        }
      });
    }
    if (loops === 10 && changed) this.runtimeIssue('Conditional rules did not settle after ten passes. Check for conflicting select/clear rules.');
    return this.deriveEffects(this.state.selections, this.state.quantities);
  };

  Configurator.prototype.selectedOptions = function (selections, effects) {
    var self = this;
    return this.config.options.filter(function (option) {
      return !effects.hiddenSteps[option.stepKey] && !effects.hiddenOptions[option.id] && self.optionSelected(option, selections);
    });
  };
  Configurator.prototype.signatureFor = function (selections, quantities, effects) {
    var tokens = this.selectedOptions(selections, effects).filter(function (option) { return option.includeInSignature; }).map(function (option) {
      return option.bundleToken || (option.stepKey + '=' + option.value);
    });
    return normalizeSignature(tokens);
  };
  Configurator.prototype.stepHasValue = function (step, selections, quantities, effects) {
    var self = this;
    if (effects.hiddenSteps[step.key] || effects.disabledSteps[step.key]) return true;
    var activeOptions = (this.optionsByStep[step.key] || []).filter(function (option) {
      return !effects.hiddenOptions[option.id] && !effects.disabledOptions[option.id];
    });
    if (activeOptions.length) return activeOptions.some(function (option) { return self.optionSelected(option, selections); });
    return (this.quantitiesByStep[step.key] || []).some(function (quantity) {
      return !effects.hiddenQuantities[quantity.id] && !effects.disabledQuantities[quantity.id] && (quantities[quantity.key] || 0) > 0;
    });
  };
  Configurator.prototype.completeFor = function (selections, quantities, effects) {
    var self = this;
    return this.config.steps.every(function (step) { return !step.required || self.stepHasValue(step, selections, quantities, effects); });
  };
  Configurator.prototype.signatureReady = function (selections, quantities, effects) {
    var self = this;
    return this.config.steps.every(function (step) {
      if (!step.required || effects.hiddenSteps[step.key] || effects.disabledSteps[step.key]) return true;
      var signatureOptions = (self.optionsByStep[step.key] || []).filter(function (option) {
        return option.includeInSignature && !effects.hiddenOptions[option.id];
      });
      return signatureOptions.length === 0 || self.stepHasValue(step, selections, quantities, effects);
    });
  };

  Configurator.prototype.resolutionSelections = function (selections, effects) {
    var self = this;
    var result = copyObject(selections);
    this.config.steps.forEach(function (step) {
      if (step.type === 'multiple') return;
      if (effects.hiddenSteps[step.key] || effects.disabledSteps[step.key]) return;
      if (result[step.key]) return;
      var defaults = (self.optionsByStep[step.key] || []).filter(function (option) {
        return option.noFallbackProduct && !effects.hiddenOptions[option.id] && !effects.disabledOptions[option.id];
      });
      if (defaults.length) result[step.key] = defaults[0].value;
    });
    return result;
  };

  Configurator.prototype.addLine = function (linesById, variantId, quantity, price, compareAt, label, source) {
    if (!validVariant(variantId) || quantity <= 0) return false;
    var key = text(variantId);
    if (!linesById[key]) linesById[key] = { id: variantId, quantity: 0, price: cents(price), compareAt: cents(compareAt), label: text(label), source: source, order: Object.keys(linesById).length };
    linesById[key].quantity += quantity;
    linesById[key].compareAt = Math.max(linesById[key].compareAt, cents(compareAt));
    return true;
  };

  Configurator.prototype.resolve = function (selections, quantities) {
    var self = this;
    var effects = this.deriveEffects(selections, quantities);
    var selected = this.selectedOptions(selections, effects);
    var activeSelectionKeys = {};
    var duplicateActiveSelection = selected.some(function (option) {
      var key = option.stepKey + ' ' + option.value;
      if (activeSelectionKeys[key]) return true;
      activeSelectionKeys[key] = true;
      return false;
    });
    var signature = this.signatureFor(selections, quantities, effects);
    var complete = this.completeFor(selections, quantities, effects);
    var signatureReady = this.signatureReady(selections, quantities, effects);
    var resolveSelections = this.resolutionSelections(selections, effects);
    var resolveSignature = this.signatureFor(resolveSelections, quantities, effects);
    var resolveReady = this.signatureReady(resolveSelections, quantities, effects);
    var exact = resolveSignature && resolveReady ? this.config.bundles.filter(function (bundle) { return bundle.signature === resolveSignature; }) : [];
    var available = exact.filter(function (bundle) { return bundle.available && validVariant(bundle.variantId); }).sort(function (left, right) {
      return right.priority - left.priority || left.price - right.price || text(left.variantId).localeCompare(text(right.variantId));
    });
    var bundle = available[0] || null;
    var pending = !signatureReady;
    var fallback = false;
    var valid = !duplicateActiveSelection && !this.hasFatalConfig;
    var reason = this.hasFatalConfig ? 'This builder has a configuration error and cannot safely resolve a cart.' : (duplicateActiveSelection ? 'This builder has duplicate active option values and cannot safely resolve a cart.' : '');
    var linesById = {};
    var referenceTotal = 0;
    var bundleIndividualTotal = 0;
    var bundleReferenceTotal = 0;
    var bundleReferenceComplete = false;
    var bundleReferenceMissing = [];
    var bundleReferenceMethod = 'none';
    if (bundle) {
      var pricedCoreCount = 0;
      selected.filter(function (option) { return option.includeInSignature && !option.addSeparately; }).forEach(function (option) {
        if (validVariant(option.variantId)) {
          bundleIndividualTotal += Math.max(0, cents(option.price));
          pricedCoreCount += 1;
        } else if (!option.noFallbackProduct) bundleReferenceMissing.push(option.label);
      });
      bundleReferenceComplete = pricedCoreCount > 0 && bundleReferenceMissing.length === 0;
      bundleReferenceTotal = bundleReferenceComplete ? Math.max(bundle.price, bundleIndividualTotal) : Math.max(bundle.price, bundle.compareAt);
      bundleReferenceMethod = bundleReferenceComplete ? 'individual-products' : (bundle.compareAt > bundle.price ? 'bundle-compare-at' : 'bundle-price-only');
    }

    if (bundle) {
      this.addLine(linesById, bundle.variantId, 1, bundle.price, bundleReferenceTotal, bundle.title, 'bundle');
      referenceTotal += bundleReferenceTotal;
    }
    else {
      var canUseIndividuals = this.config.fallbackMode === 'individual' || pending || !signature;
      if (canUseIndividuals) {
        fallback = !!signature;
        selected.forEach(function (option) {
          if (!validVariant(option.variantId)) {
            if (!option.addSeparately && (pending || option.noFallbackProduct)) return;
            valid = false;
            reason = 'A selected choice is missing its individual fallback product.';
            return;
          }
          if (!option.available) {
            if (pending && !option.addSeparately) return;
            valid = false;
            reason = 'A selected product is unavailable.';
            return;
          }
          if (self.addLine(linesById, option.variantId, 1, option.price, option.compareAt, option.label, option.addSeparately ? 'addon' : 'individual')) {
            referenceTotal += Math.max(cents(option.price), cents(option.compareAt));
          }
        });
      } else {
        valid = false;
        reason = exact.length ? 'This bundle combination is currently unavailable.' : 'No bundle is configured for this combination.';
      }
    }

    if (bundle) {
      selected.filter(function (option) { return option.addSeparately; }).forEach(function (option) {
        if (!option.available || !validVariant(option.variantId)) {
          valid = false;
          reason = 'A selected add-on is unavailable.';
          return;
        }
        if (self.addLine(linesById, option.variantId, 1, option.price, option.compareAt, option.label, 'addon')) {
          referenceTotal += Math.max(cents(option.price), cents(option.compareAt));
        }
      });
    }

    this.config.quantities.forEach(function (quantity) {
      if (effects.hiddenSteps[quantity.stepKey] || effects.hiddenQuantities[quantity.id]) return;
      var count = self.clampQuantity(quantity, quantities[quantity.key] || 0);
      if (!count) return;
      if (!quantity.available || !validVariant(quantity.variantId)) {
        valid = false;
        reason = 'A selected quantity add-on is unavailable.';
        return;
      }
      if (self.addLine(linesById, quantity.variantId, count, quantity.price, quantity.compareAt, quantity.label, 'quantity')) {
        referenceTotal += Math.max(cents(quantity.price), cents(quantity.compareAt)) * count;
      }
    });

    var sourceOrder = { bundle: 0, individual: 1, addon: 2, quantity: 3 };
    var lines = Object.keys(linesById).map(function (key) { return linesById[key]; }).sort(function (left, right) {
      return (sourceOrder[left.source] || 0) - (sourceOrder[right.source] || 0) || left.order - right.order;
    });
    var total = lines.reduce(function (sum, line) { return sum + line.price * line.quantity; }, 0);
    var compareAtTotal = Math.max(total, referenceTotal);
    var savings = Math.max(0, compareAtTotal - total);
    if (complete && lines.length === 0) {
      valid = false;
      reason = reason || 'This build has no purchasable products.';
    }
    return {
      signature: signature,
      bundle: bundle,
      exactMatches: exact.length,
      availableExactMatches: available.length,
      pending: pending,
      fallback: fallback && !bundle,
      valid: valid,
      reason: reason,
      complete: complete,
      total: total,
      compareAtTotal: compareAtTotal,
      savings: savings,
      referenceTotal: referenceTotal,
      bundleIndividualTotal: bundleIndividualTotal,
      bundleReferenceTotal: bundleReferenceTotal,
      bundleReferenceComplete: bundleReferenceComplete,
      bundleReferenceMissing: bundleReferenceMissing,
      bundleReferenceMethod: bundleReferenceMethod,
      lines: lines,
      effects: effects
    };
  };

  Configurator.prototype.hypotheticalOption = function (option) {
    var selections = copyObject(this.state.selections);
    var selected = this.optionSelected(option, selections);
    if (selected) {
      this.setOptionState(option, false, selections);
      var without = this.resolve(selections, copyObject(this.state.quantities));
      return { resolution: without, delta: without.valid ? this.resolution.total - without.total : option.price, selected: true };
    }
    this.setOptionState(option, true, selections);
    var withOption = this.resolve(selections, copyObject(this.state.quantities));
    return { resolution: withOption, delta: withOption.total - this.resolution.total, selected: false };
  };
  Configurator.prototype.hypotheticalQuantity = function (item) {
    var quantities = copyObject(this.state.quantities);
    var current = quantities[item.key] || 0;
    quantities[item.key] = current ? Math.min(item.max, current + 1) : Math.max(1, item.min);
    var next = this.resolve(copyObject(this.state.selections), quantities);
    return { resolution: next, delta: next.total - this.resolution.total };
  };

  Configurator.prototype.formatMoney = function (value) {
    var amount = integer(value, 0) / 100;
    try { return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(amount); }
    catch (error) { return this.config.currency + ' ' + amount.toFixed(2); }
  };
  Configurator.prototype.formatDelta = function (delta, valid, selected) {
    if (!valid) return this.config.strings.unavailable;
    if (delta === 0) return selected ? this.config.strings.included : this.config.strings.noChange;
    return (delta > 0 ? '+' : '−') + this.formatMoney(Math.abs(delta));
  };

  Configurator.prototype.cardsForOption = function (option) {
    return list(this.root.querySelectorAll('[data-scpc-option-card]')).filter(function (card) {
      var cardKey = attributeKey(card, 'data-scpc-option-card');
      var buttonKey = attributeKey(card, 'data-scpc-option');
      return card.getAttribute('data-option-id') === option.id || card.getAttribute('data-value') === option.value ||
        cardKey === option.id || cardKey === option.value || buttonKey === option.id || buttonKey === option.value;
    });
  };
  Configurator.prototype.cardsForQuantity = function (item) {
    return list(this.root.querySelectorAll('[data-scpc-quantity]')).filter(function (card) {
      var key = attributeKey(card, 'data-scpc-quantity');
      return card.getAttribute('data-quantity-id') === item.id || card.getAttribute('data-quantity-key') === item.key || key === item.id || key === item.key;
    });
  };
  Configurator.prototype.stepElements = function (step) {
    return list(this.root.querySelectorAll('[data-scpc-step]')).filter(function (element) { return element.getAttribute('data-scpc-step') === step.key; });
  };

  Configurator.prototype.renderOptions = function () {
    var self = this;
    this.config.options.forEach(function (option) {
      var selected = self.optionSelected(option, self.state.selections);
      var hypothetical = self.hypotheticalOption(option);
      var conditionalHidden = !!self.resolution.effects.hiddenOptions[option.id] || !!self.resolution.effects.hiddenSteps[option.stepKey];
      var ruleDisabled = !!self.resolution.effects.disabledOptions[option.id] || !!self.resolution.effects.disabledSteps[option.stepKey];
      var outOfStock = !option.available && !option.noFallbackProduct;
      var unavailable = outOfStock || ruleDisabled || (!selected ? !hypothetical.resolution.valid : (!self.resolution.valid && hypothetical.resolution.valid));
      var hideInvalid = self.config.fallbackMode === 'hide' && unavailable && !selected;
      self.cardsForOption(option).forEach(function (card) {
        setElementHidden(card, conditionalHidden || hideInvalid);
        card.classList.toggle('is-selected', selected);
        card.classList.toggle('is-disabled', unavailable);
        card.classList.toggle('is-recommended', !!self.recommended && self.recommended.optionId === option.id);
        card.setAttribute('data-scpc-selected', selected ? 'true' : 'false');
        var button = matches(card, '[data-scpc-option]') ? card : card.querySelector('[data-scpc-option]');
        if (button) {
          var multiple = self.stepsByKey[option.stepKey] && self.stepsByKey[option.stepKey].type === 'multiple';
          var canClearInvalidSingle = selected && !multiple && !self.resolution.valid && hypothetical.resolution.valid;
          var interactionBlocked = outOfStock || (unavailable && !(selected && multiple) && !canClearInvalidSingle);
          button.disabled = interactionBlocked;
          button.setAttribute('aria-disabled', interactionBlocked ? 'true' : 'false');
          if (multiple) {
            button.setAttribute('role', 'button');
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
            button.removeAttribute('aria-checked');
          } else {
            button.setAttribute('role', 'radio');
            button.setAttribute('aria-checked', selected ? 'true' : 'false');
            button.removeAttribute('aria-pressed');
          }
        }
        list(card.querySelectorAll('[data-scpc-option-price]')).forEach(function (price) {
          // Stock state wins: an unavailable SKU never reads as Included or a price.
          if (!option.available || (option.variantId && !validVariant(option.variantId) && !option.noFallbackProduct)) {
            price.textContent = self.config.strings.unavailable;
            return;
          }
          price.textContent = self.formatDelta(hypothetical.delta, hypothetical.resolution.valid || selected, selected);
        });
      });
    });
    this.config.steps.filter(function (step) { return step.type === 'single'; }).forEach(function (step) {
      var radios = [];
      (self.optionsByStep[step.key] || []).forEach(function (option) {
        self.cardsForOption(option).forEach(function (card) {
          var button = matches(card, '[data-scpc-option]') ? card : card.querySelector('[data-scpc-option]');
          if (button && !button.disabled && !card.hidden) radios.push({ button: button, selected: self.optionSelected(option, self.state.selections) });
        });
      });
      var active = radios.filter(function (radio) { return radio.selected; })[0] || radios[0];
      radios.forEach(function (radio) { radio.button.setAttribute('tabindex', radio === active ? '0' : '-1'); });
    });
  };

  Configurator.prototype.renderQuantities = function () {
    var self = this;
    this.config.quantities.forEach(function (item) {
      var quantity = self.state.quantities[item.key] || 0;
      var hypothetical = self.hypotheticalQuantity(item);
      var hidden = !!self.resolution.effects.hiddenQuantities[item.id] || !!self.resolution.effects.hiddenSteps[item.stepKey];
      var ruleDisabled = !!self.resolution.effects.disabledQuantities[item.id] || !!self.resolution.effects.disabledSteps[item.stepKey];
      var addBlocked = ruleDisabled || !item.available || !validVariant(item.variantId) || !hypothetical.resolution.valid;
      self.cardsForQuantity(item).forEach(function (card) {
        setElementHidden(card, hidden);
        card.classList.toggle('is-selected', quantity > 0);
        card.classList.toggle('is-disabled', addBlocked);
        list(card.querySelectorAll('[data-scpc-quantity-input]')).forEach(function (input) {
          input.value = String(quantity);
          input.disabled = ruleDisabled || (addBlocked && quantity === 0);
          input.setAttribute('aria-valuemin', '0');
          input.setAttribute('aria-valuemax', String(item.max));
          input.setAttribute('aria-valuenow', String(quantity));
        });
        list(card.querySelectorAll('[data-scpc-quantity-value], [data-scpc-quantity-output]')).forEach(function (value) { value.textContent = String(quantity); });
        list(card.querySelectorAll('[data-scpc-quantity-minus]')).forEach(function (button) { button.disabled = ruleDisabled || quantity === 0; });
        list(card.querySelectorAll('[data-scpc-quantity-plus]')).forEach(function (button) { button.disabled = addBlocked || quantity >= item.max; });
        list(card.querySelectorAll('[data-scpc-quantity-price]')).forEach(function (price) {
          var displayDelta = quantity >= item.max ? item.price : hypothetical.delta;
          price.textContent = self.formatDelta(displayDelta, hypothetical.resolution.valid, false);
        });
      });
    });
  };

  Configurator.prototype.summaryForStep = function (step) {
    var self = this;
    var labels = (this.optionsByStep[step.key] || []).filter(function (option) { return self.optionSelected(option, self.state.selections); }).map(function (option) { return option.label; });
    (this.quantitiesByStep[step.key] || []).forEach(function (item) {
      var quantity = self.state.quantities[item.key] || 0;
      if (quantity) labels.push(item.label + ' × ' + quantity);
    });
    return labels.length ? labels.join(', ') : step.subheading;
  };
  Configurator.prototype.renderSteps = function () {
    var self = this;
    if (this.state.openStep && (this.resolution.effects.hiddenSteps[this.state.openStep] || this.resolution.effects.disabledSteps[this.state.openStep])) {
      var replacement = this.config.steps.filter(function (candidate) { return !self.resolution.effects.hiddenSteps[candidate.key] && !self.resolution.effects.disabledSteps[candidate.key]; })[0];
      this.state.openStep = replacement ? replacement.key : '';
    }
    var openExists = false;
    this.config.steps.forEach(function (step) {
      var hidden = !!self.resolution.effects.hiddenSteps[step.key];
      var disabled = !!self.resolution.effects.disabledSteps[step.key];
      var complete = self.stepHasValue(step, self.state.selections, self.state.quantities, self.resolution.effects);
      var open = !hidden && !disabled && self.state.openStep === step.key;
      if (open) openExists = true;
      self.stepElements(step).forEach(function (element) {
        setElementHidden(element, hidden);
        element.classList.toggle('is-open', open);
        element.classList.toggle('is-complete', complete);
        element.classList.toggle('is-disabled', disabled);
        var toggle = element.querySelector('[data-scpc-step-toggle]');
        var panel = element.querySelector('[data-scpc-step-panel]');
        var status = element.querySelector('[data-scpc-step-status]');
        var optionGroup = element.querySelector('.scpc__option-grid, [data-scpc-option-group]');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (toggle) toggle.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        if (toggle) toggle.disabled = disabled;
        if (panel) panel.hidden = !open;
        if (status) status.textContent = complete ? '✓' : '';
        if (optionGroup) optionGroup.setAttribute('role', step.type === 'single' ? 'radiogroup' : 'group');
        list(element.querySelectorAll('[data-scpc-step-summary]')).forEach(function (summary) { summary.textContent = self.summaryForStep(step); });
      });
    });
    if (!openExists && this.state.openStep) this.openFirstVisibleStep();
  };

  Configurator.prototype.renderReview = function () {
    var self = this;
    var panel = this.root.querySelector('[data-scpc-review-panel], [data-scpc-review]');
    var trigger = this.root.querySelector('[data-scpc-review-toggle]');
    if (panel) panel.hidden = !this.reviewOpen;
    if (trigger) trigger.setAttribute('aria-expanded', this.reviewOpen ? 'true' : 'false');
    list(this.root.querySelectorAll('[data-scpc-review-lines]')).forEach(function (container) {
      clear(container);
      self.resolution.lines.forEach(function (line) {
        var row = document.createElement(container.tagName === 'UL' || container.tagName === 'OL' ? 'li' : 'div');
        var label = document.createElement('span');
        var price = document.createElement('span');
        label.textContent = line.label + (line.quantity > 1 ? ' × ' + line.quantity : '');
        if (line.source === 'bundle' || line.source === 'addon' || line.source === 'quantity') {
          var source = document.createElement('small');
          source.className = 'scpc__review-source';
          source.textContent = line.source === 'bundle' ? self.config.strings.bundle : self.config.strings.extra;
          label.appendChild(source);
        }
        price.textContent = self.formatMoney(line.price * line.quantity);
        row.className = 'scpc__review-line';
        row.appendChild(label);
        row.appendChild(price);
        container.appendChild(row);
      });
      if (self.resolution.lines.length) {
        if (self.resolution.savings > 0) {
          var referenceRow = document.createElement(container.tagName === 'UL' || container.tagName === 'OL' ? 'li' : 'div');
          var referenceLabel = document.createElement('span');
          var referencePrice = document.createElement('s');
          referenceRow.className = 'scpc__review-reference';
          referenceLabel.textContent = self.config.strings.referenceTotal;
          referencePrice.textContent = self.formatMoney(self.resolution.compareAtTotal);
          referenceRow.appendChild(referenceLabel);
          referenceRow.appendChild(referencePrice);
          container.appendChild(referenceRow);

          var savingRow = document.createElement(container.tagName === 'UL' || container.tagName === 'OL' ? 'li' : 'div');
          var savingLabel = document.createElement('span');
          var savingPrice = document.createElement('strong');
          savingRow.className = 'scpc__review-saving';
          savingLabel.textContent = self.config.strings.savings;
          savingPrice.textContent = '−' + self.formatMoney(self.resolution.savings);
          savingRow.appendChild(savingLabel);
          savingRow.appendChild(savingPrice);
          container.appendChild(savingRow);
        }
        var totalRow = document.createElement(container.tagName === 'UL' || container.tagName === 'OL' ? 'li' : 'div');
        var totalLabel = document.createElement('span');
        var totalPrice = document.createElement('strong');
        totalRow.className = 'scpc__review-total';
        totalLabel.textContent = 'Total';
        totalPrice.textContent = self.formatMoney(self.resolution.total);
        totalRow.appendChild(totalLabel);
        totalRow.appendChild(totalPrice);
        container.appendChild(totalRow);
      }
    });
    list(this.root.querySelectorAll('[data-scpc-review-total]')).forEach(function (element) { element.textContent = self.formatMoney(self.resolution.total); });
  };

  Configurator.prototype.renderContextAndProgress = function () {
    var self = this;
    var effects = this.resolution.effects;
    var visibleSteps = this.config.steps.filter(function (step) { return !effects.hiddenSteps[step.key]; });
    var countedSteps = this.config.progressAllSteps ? visibleSteps.slice() : visibleSteps.filter(function (step) { return step.required; });
    if (!countedSteps.length) countedSteps = visibleSteps;
    var complete = countedSteps.filter(function (step) { return self.stepHasValue(step, self.state.selections, self.state.quantities, effects); }).length;
    var percent = countedSteps.length ? Math.round(complete / countedSteps.length * 100) : 100;
    list(this.root.querySelectorAll('[data-scpc-progress]')).forEach(function (bar) {
      bar.style.width = percent + '%';
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '100');
      bar.setAttribute('aria-valuenow', String(percent));
    });
    list(this.root.querySelectorAll('[data-scpc-progress-checks]')).forEach(function (container) {
      if (container.childElementCount !== countedSteps.length + 1) {
        clear(container);
        container.appendChild(document.createElement('span'));
        for (var checkIndex = 0; checkIndex < countedSteps.length; checkIndex += 1) {
          var check = document.createElement('span');
          check.className = 'scpc__check';
          check.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4.5 12.75 6 6 9-13.5"/></svg>';
          container.appendChild(check);
        }
      }
      list(container.querySelectorAll('.scpc__check')).forEach(function (check, checkIndex) {
        check.classList.toggle('is-done', checkIndex < complete);
      });
    });
    list(this.root.querySelectorAll('[data-scpc-progress-copy]')).forEach(function (copy) {
      copy.textContent = countedSteps.length && complete === countedSteps.length ? 'Your build is ready.' : complete + ' of ' + countedSteps.length + ' steps complete';
    });

    var item = this.optionsById[this.lastChoiceId] || this.quantitiesById[this.lastChoiceId] || null;
    var selectedLabels = this.selectedOptions(this.state.selections, effects).map(function (option) { return option.label; });
    this.config.quantities.forEach(function (quantity) {
      var amount = self.state.quantities[quantity.key] || 0;
      if (amount && !effects.hiddenQuantities[quantity.id]) selectedLabels.push(quantity.label + (amount > 1 ? ' × ' + amount : ''));
    });
    var title = item ? item.label : (this.resolution.bundle ? this.resolution.bundle.title : (this.initialContextTitle || 'Make your first selection'));
    var summary = item && item.subtext ? item.subtext : ((item || this.resolution.bundle) && selectedLabels.length ? selectedLabels.slice(-3).join(' · ') : this.initialContextSummary);
    list(this.root.querySelectorAll('[data-scpc-context-title]')).forEach(function (element) { element.textContent = title; });
    list(this.root.querySelectorAll('[data-scpc-context-summary]')).forEach(function (element) { element.textContent = summary; });
    var recommendedSelected = !!(this.recommended && this.optionsById[this.recommended.optionId] && this.optionSelected(this.optionsById[this.recommended.optionId], this.state.selections));
    list(this.root.querySelectorAll('[data-scpc-context-badge]')).forEach(function (badge) { badge.hidden = !recommendedSelected; });
  };

  Configurator.prototype.renderStatus = function () {
    var message = '';
    if (this.cartMessage) message = this.cartMessage;
    else if (!this.resolution.valid) message = this.resolution.reason;
    else if (this.config.requireComplete && !this.resolution.complete) message = this.config.strings.selectRequired;
    else if (this.resolution.fallback && this.resolution.complete) message = 'This build uses its individual products.';
    list(this.root.querySelectorAll('[data-scpc-status]')).forEach(function (status) { status.textContent = message; });
  };

  Configurator.prototype.firstIncompleteStep = function () {
    var self = this;
    var effects = (this.resolution && this.resolution.effects) || this.deriveEffects(this.state.selections, this.state.quantities);
    return this.config.steps.filter(function (step) {
      if (!step.required || effects.hiddenSteps[step.key] || effects.disabledSteps[step.key]) return false;
      return !self.stepHasValue(step, self.state.selections, self.state.quantities, effects);
    })[0] || null;
  };
  Configurator.prototype.canAddNow = function () {
    return !this.adding && !!this.resolution && this.resolution.valid && this.resolution.lines.length > 0 && !(this.config.requireComplete && !this.resolution.complete);
  };
  Configurator.prototype.guideLabel = function (step) {
    return (step && text(step.label).trim()) || this.config.strings.selectRequired;
  };
  Configurator.prototype.openStepForGuide = function (key) {
    if (!this.stepsByKey[key]) return;
    this.state.openStep = key;
    this.renderSteps();
    var element = this.stepElements(this.stepsByKey[key])[0];
    if (element && element.scrollIntoView) {
      scpcScrollStep(element, 'center');
    }
    var toggle = element && element.querySelector('[data-scpc-step-toggle]');
    if (toggle) { try { toggle.focus({ preventScroll: true }); } catch (error) { toggle.focus(); } }
  };

  Configurator.prototype.setFloatingBar = function (on) {
    var bar = this.root.querySelector('[data-scpc-purchase-bar]');
    if (!bar || this.barFloating === !!on) return;
    this.barFloating = !!on;
    if (on) {
      this.barSpacer = document.createElement('div');
      this.barSpacer.style.height = bar.offsetHeight + 'px';
      bar.parentNode.insertBefore(this.barSpacer, bar);
      bar.classList.add('is-floating');
    } else {
      bar.classList.remove('is-floating');
      if (this.barSpacer && this.barSpacer.parentNode) this.barSpacer.parentNode.removeChild(this.barSpacer);
      this.barSpacer = null;
    }
  };

  Configurator.prototype.render = function () {
    var self = this;
    this.renderSteps();
    this.renderOptions();
    this.renderQuantities();
    this.renderReview();
    this.renderContextAndProgress();
    this.renderStatus();
    list(this.root.querySelectorAll('[data-scpc-total]')).forEach(function (element) { element.textContent = self.formatMoney(self.resolution.total); });
    list(this.root.querySelectorAll('[data-scpc-compare-total]')).forEach(function (element) {
      element.textContent = self.formatMoney(self.resolution.compareAtTotal);
      element.hidden = self.resolution.savings <= 0;
    });
    list(this.root.querySelectorAll('[data-scpc-savings]')).forEach(function (element) {
      element.textContent = self.config.strings.savings + ' ' + self.formatMoney(self.resolution.savings);
      element.hidden = self.resolution.savings <= 0;
    });
    var canAdd = this.canAddNow();
    var incompleteStep = canAdd ? null : this.firstIncompleteStep();
    var guiding = !this.adding && !canAdd && !!incompleteStep;
    // Hard-disable only when nothing here helps (mid-add, invalid config, unavailable, or nothing purchasable). Guiding stays clickable so it can navigate.
    var hardDisabled = this.adding || (!canAdd && !guiding);
    list(this.root.querySelectorAll('[data-scpc-add]')).forEach(function (button) {
      button.disabled = hardDisabled;
      button.setAttribute('aria-disabled', hardDisabled ? 'true' : 'false');
      button.classList.toggle('is-loading', self.adding);
      button.classList.toggle('is-guide', guiding);
      button.setAttribute('data-scpc-guide-step', guiding && incompleteStep ? incompleteStep.key : '');
      var addLabelEl = button.querySelector('span');
      if (addLabelEl) {
        addLabelEl.textContent = self.adding ? self.config.strings.adding : (guiding ? self.guideLabel(incompleteStep) : self.addLabelComplete);
      }
    });
    this.root.setAttribute('data-scpc-signature', this.resolution.signature);
    this.root.setAttribute('data-scpc-total-cents', String(this.resolution.total));
    this.root.setAttribute('data-scpc-compare-total-cents', String(this.resolution.compareAtTotal));
    this.root.setAttribute('data-scpc-savings-cents', String(this.resolution.savings));
    this.root.setAttribute('data-scpc-resolution-mode', this.resolution.bundle ? 'bundle' : (this.resolution.pending ? 'pending' : (this.resolution.fallback ? 'individual' : 'unresolved')));
    this.root.setAttribute('data-scpc-exact-matches', String(this.resolution.exactMatches));
    this.root.setAttribute('data-scpc-available-exact-matches', String(this.resolution.availableExactMatches));
    this.root.setAttribute('data-scpc-bundle-reference-method', this.resolution.bundleReferenceMethod);
    this.renderDiagnostics();
  };

  Configurator.prototype.detail = function () {
    var bundle = this.resolution.bundle;
    return {
      contractVersion: 1,
      sectionId: this.config.sectionId,
      builderKey: this.config.builderKey,
      selections: copyObject(this.state.selections),
      quantities: copyObject(this.state.quantities),
      signature: this.resolution.signature,
      bundle: bundle ? { productId: bundle.productId, variantId: bundle.variantId, title: bundle.title, signature: bundle.signature, priority: bundle.priority, price: bundle.price, compareAt: bundle.compareAt, available: bundle.available } : null,
      fallback: this.resolution.fallback,
      total: this.resolution.total,
      compareAtTotal: this.resolution.compareAtTotal,
      savings: this.resolution.savings,
      referenceTotal: this.resolution.referenceTotal,
      exactMatches: this.resolution.exactMatches,
      availableExactMatches: this.resolution.availableExactMatches,
      bundleIndividualTotal: this.resolution.bundleIndividualTotal,
      bundleReferenceTotal: this.resolution.bundleReferenceTotal,
      bundleReferenceComplete: this.resolution.bundleReferenceComplete,
      bundleReferenceMissing: this.resolution.bundleReferenceMissing.slice(),
      bundleReferenceMethod: this.resolution.bundleReferenceMethod,
      lines: this.resolution.lines.map(function (line) { return { id: line.id, quantity: line.quantity, price: line.price, compareAt: line.compareAt, label: line.label, source: line.source }; }),
      complete: this.resolution.complete,
      valid: this.resolution.valid,
      connectedValue: this.connectedValue(),
      changedKey: this.lastChangedKey
    };
  };
  Configurator.prototype.connectedValue = function () {
    var value = this.config.connectedValueKey ? this.valueFor(this.config.connectedValueKey, this.state.selections, this.state.quantities) : '';
    return Array.isArray(value) ? value[0] || '' : value || '';
  };
  Configurator.prototype.publish = function () {
    var detail = this.detail();
    dispatch(this.root, 'sc-configurator-change', detail);
    dispatch(this.root, 'sc-configurator:change', detail);
    if (this.config.legacyEvent) {
      var current = text(this.connectedValue());
      this.root.setAttribute('data-seedcube-size', current);
      this.root.setAttribute('data-seedcube-builder', '');
      dispatch(this.root, typeof this.config.legacyEvent === 'string' ? this.config.legacyEvent : 'seedcube:builder-state', {
        contractVersion: 1,
        sectionId: this.config.sectionId,
        size: current || null,
        previousSize: this.lastLegacyValue,
        initial: this.initialEvent
      });
      this.lastLegacyValue = current || null;
    }
    this.initialEvent = false;
  };
  Configurator.prototype.update = function (changedKey) {
    if (this.destroyed) return;
    this.lastChangedKey = changedKey || '';
    if (changedKey) this.cartMessage = '';
    this.stabiliseState();
    this.resolution = this.resolve(this.state.selections, this.state.quantities);
    this.persist();
    this.render();
    this.syncMediaAfterState();
    this.publish();
  };

  Configurator.prototype.selectInitialStep = function () {
    var preferred = this.config.steps.filter(function (step) { return step.open; })[0];
    this.state.openStep = preferred ? preferred.key : (this.config.steps[0] ? this.config.steps[0].key : '');
  };
  Configurator.prototype.openFirstVisibleStep = function () {
    var self = this;
    var step = this.config.steps.filter(function (candidate) { return !self.resolution.effects.hiddenSteps[candidate.key] && !self.resolution.effects.disabledSteps[candidate.key]; })[0];
    this.state.openStep = step ? step.key : '';
  };
  Configurator.prototype.openStep = function (key, scroll) {
    if (!this.stepsByKey[key] || (this.resolution && (this.resolution.effects.hiddenSteps[key] || this.resolution.effects.disabledSteps[key]))) return;
    this.state.openStep = this.state.openStep === key ? '' : key;
    this.renderSteps();
    if (scroll && this.state.openStep) {
      var element = this.stepElements(this.stepsByKey[key])[0];
      if (element && element.scrollIntoView) {
        scpcScrollStep(element, 'nearest');
      }
    }
  };
  Configurator.prototype.advanceFrom = function (stepKey) {
    var current = this.config.steps.map(function (step) { return step.key; }).indexOf(stepKey);
    if (current < 0) return;
    for (var index = current + 1; index < this.config.steps.length; index += 1) {
      var next = this.config.steps[index];
      if (!this.resolution.effects.hiddenSteps[next.key] && !this.resolution.effects.disabledSteps[next.key]) {
        this.state.openStep = next.key;
        this.renderSteps();
        var element = this.stepElements(next)[0];
        var toggle = element && element.querySelector('[data-scpc-step-toggle]');
        if (toggle) window.requestAnimationFrame(function () {
          try { toggle.focus({ preventScroll: true }); } catch (error) { toggle.focus(); }
          if (element.scrollIntoView) {
            scpcScrollStep(element, 'nearest');
          }
        });
        return;
      }
    }
  };

  Configurator.prototype.handleOptionArrow = function (event) {
    if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(event.key) < 0) return false;
    var current = this.findOption(event.target);
    var step = current && this.stepsByKey[current.stepKey];
    if (!current || !step || step.type !== 'single') return false;
    var self = this;
    var choices = (this.optionsByStep[step.key] || []).map(function (option) {
      var card = self.cardsForOption(option)[0];
      var button = card && (matches(card, '[data-scpc-option]') ? card : card.querySelector('[data-scpc-option]'));
      return card && !card.hidden && button && !button.disabled ? { option: option, button: button } : null;
    }).filter(Boolean);
    if (choices.length < 2) return false;
    var index = choices.map(function (choice) { return choice.option.id; }).indexOf(current.id);
    if (index < 0) return false;
    event.preventDefault();
    var forward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
    index = (index + (forward ? 1 : -1) + choices.length) % choices.length;
    this.chooseOption(choices[index].option, true);
    choices[index].button.focus();
    return true;
  };

  Configurator.prototype.findOption = function (element) {
    var button = closest(element, '[data-scpc-option]', this.root);
    if (!button) return null;
    var key = button.getAttribute('data-scpc-option');
    if (this.optionsById[key]) return this.optionsById[key];
    var valueMatch = this.config.options.filter(function (option) { return option.value === key; });
    if (valueMatch.length === 1) return valueMatch[0];
    var card = closest(button, '[data-scpc-option-card]', this.root);
    if (card) {
      if (this.optionsById[card.getAttribute('data-option-id')]) return this.optionsById[card.getAttribute('data-option-id')];
      var cardKey = card.getAttribute('data-scpc-option-card');
      if (this.optionsById[cardKey]) return this.optionsById[cardKey];
      valueMatch = this.config.options.filter(function (option) { return option.value === cardKey; });
      if (valueMatch.length === 1) return valueMatch[0];
    }
    return null;
  };
  Configurator.prototype.findQuantity = function (element) {
    var card = closest(element, '[data-scpc-quantity]', this.root);
    if (!card) return null;
    var key = card.getAttribute('data-scpc-quantity');
    return this.quantitiesById[card.getAttribute('data-quantity-id')] || this.quantitiesByKey[card.getAttribute('data-quantity-key')] || this.quantitiesById[key] || this.quantitiesByKey[key] || null;
  };
  Configurator.prototype.chooseOption = function (option, suppressAdvance) {
    if (!option) return;
    var effects = this.resolution.effects;
    if (effects.hiddenSteps[option.stepKey] || effects.disabledSteps[option.stepKey] || effects.hiddenOptions[option.id] || effects.disabledOptions[option.id]) return;
        // Out-of-stock options are never selectable.
    if (!option.available && !option.noFallbackProduct) return;
    var selected = this.optionSelected(option, this.state.selections);
    var step = this.stepsByKey[option.stepKey];
    var hypothetical = this.hypotheticalOption(option);
    if (!selected && !hypothetical.resolution.valid) return;
    var clearingInvalidSingle = !!(selected && step && step.type !== 'multiple' && !this.resolution.valid && hypothetical.resolution.valid);
    this.lastChoiceId = clearingInvalidSingle ? '' : option.id;
    this.setOptionState(option, step && step.type === 'multiple' ? !selected : !clearingInvalidSingle, this.state.selections);
        // Changing the size resets the rest of the build so nothing stale carries over.
    if (option.stepKey === this.config.connectedValueKey && !clearingInvalidSingle) {
      var sizeKey = option.stepKey;
      var self = this;
      this.config.steps.forEach(function (s) {
        if (s.key === sizeKey) return;
        self.state.selections[s.key] = s.type === 'multiple' ? [] : '';
      });
      Object.keys(this.state.quantities).forEach(function (k) {
        self.state.quantities[k] = 0;
      });
    }
    if (!clearingInvalidSingle && option.changesMedia && option.mediaKey) this.setMedia(option.mediaKey);
    this.update(option.stepKey);
    if (!clearingInvalidSingle && !suppressAdvance && this.config.autoAdvance && step && step.autoAdvance && (step.type !== 'multiple' || !selected)) this.advanceFrom(step.key);
  };
  Configurator.prototype.changeQuantity = function (item, directionOrValue) {
    if (!item || this.resolution.effects.hiddenSteps[item.stepKey] || this.resolution.effects.disabledSteps[item.stepKey] || this.resolution.effects.hiddenQuantities[item.id] || this.resolution.effects.disabledQuantities[item.id]) return;
    var current = this.state.quantities[item.key] || 0;
    this.lastChoiceId = item.id;
    var next;
    if (directionOrValue === 'increase') next = current ? current + 1 : Math.max(1, item.min);
    else if (directionOrValue === 'decrease') next = current <= Math.max(1, item.min) ? 0 : current - 1;
    else next = directionOrValue;
    next = this.clampQuantity(item, next);
    if ((!item.available || !validVariant(item.variantId)) && next >= current && next !== 0) return;
    this.state.quantities[item.key] = next;
    if (this.state.quantities[item.key] && item.changesMedia && item.mediaKey) this.setMedia(item.mediaKey);
    this.update(item.key);
  };

  Configurator.prototype.templateFor = function (mediaKey) {
    var templates = list(this.root.querySelectorAll('template[data-scpc-media-template]'));
    for (var index = 0; index < templates.length; index += 1) {
      if (templates[index].getAttribute('data-scpc-media-template') === mediaKey) return templates[index];
    }
    return null;
  };
  Configurator.prototype.cloneMedia = function (mediaKey, destination) {
    var template = this.templateFor(mediaKey);
    if (!template || !destination || !template.content.querySelector('[data-scpc-media-slide]')) return false;
    pauseVideos(destination);
    clear(destination);
    destination.appendChild(template.content.cloneNode(true));
    list(destination.querySelectorAll('video')).forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
    });
    if (destination === this.root.querySelector('[data-scpc-media-root]')) {
      destination.scrollLeft = 0;
      this.renderMediaNav();
      this.syncMediaNav();
    }
    return true;
  };
  Configurator.prototype.renderMediaNav = function () {
    var self = this;
    var destination = this.root.querySelector('[data-scpc-media-root]');
    var nav = this.root.querySelector('[data-scpc-media-nav]');
    if (!destination || !nav) return;
    var slides = list(destination.querySelectorAll('[data-scpc-media-slide]'));
    clear(nav);
    slides.forEach(function (slide, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'scpc__media-dot';
      button.setAttribute('data-scpc-media-index', String(index));
      button.setAttribute('aria-label', 'View media ' + (index + 1) + ' of ' + slides.length);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      nav.appendChild(button);
    });
    nav.hidden = slides.length < 2;
    destination.setAttribute('aria-label', slides.length + (slides.length === 1 ? ' product media item' : ' product media items'));
  };
  Configurator.prototype.syncMediaNav = function () {
    var destination = this.root.querySelector('[data-scpc-media-root]');
    var nav = this.root.querySelector('[data-scpc-media-nav]');
    if (!destination || !nav) return;
    var slides = list(destination.querySelectorAll('[data-scpc-media-slide]'));
    var width = destination.clientWidth || 1;
    var current = Math.max(0, Math.min(slides.length - 1, Math.round(destination.scrollLeft / width)));
    list(nav.querySelectorAll('[data-scpc-media-index]')).forEach(function (button, index) { button.setAttribute('aria-current', index === current ? 'true' : 'false'); });
    slides.forEach(function (slide, index) {
      if (index !== current) pauseVideos(slide);
      else list(slide.querySelectorAll('video[autoplay]')).forEach(function (video) {
        var promise;
        try { promise = video.play(); } catch (error) { promise = null; }
        if (promise && promise.catch) promise.catch(function () {});
      });
      slide.setAttribute('aria-hidden', index === current ? 'false' : 'true');
      if ('inert' in slide) slide.inert = index !== current;
    });
  };
  Configurator.prototype.scrollMediaTo = function (index) {
    var destination = this.root.querySelector('[data-scpc-media-root]');
    if (!destination) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var left = Math.max(0, integer(index, 0)) * destination.clientWidth;
    try { destination.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' }); }
    catch (error) { destination.scrollLeft = left; }
  };
  Configurator.prototype.setMedia = function (mediaKey) {
    if (!mediaKey || mediaKey === this.currentMediaKey) return;
    var destination = this.root.querySelector('[data-scpc-media-root]');
    if (this.cloneMedia(mediaKey, destination)) {
      this.currentMediaKey = mediaKey;
      this.root.setAttribute('data-scpc-media-key', mediaKey);
    }
  };
  Configurator.prototype.restoreInitialMedia = function () {
    var destination = this.root.querySelector('[data-scpc-media-root]');
    if (!destination || !this.initialMediaNodes.length) return false;
    pauseVideos(destination);
    clear(destination);
    this.initialMediaNodes.forEach(function (node) { destination.appendChild(node.cloneNode(true)); });
    destination.scrollLeft = 0;
    this.currentMediaKey = '__default';
    this.root.setAttribute('data-scpc-media-key', '__default');
    this.renderMediaNav();
    this.syncMediaNav();
    return true;
  };
  Configurator.prototype.selectInitialMedia = function () {
    var self = this;
    var selected = this.config.options.filter(function (option) {
      var template = option.mediaKey && self.templateFor(option.mediaKey);
      return option.changesMedia && template && template.content.querySelector('[data-scpc-media-slide]') && self.optionSelected(option, self.state.selections);
    });
    var first = selected[selected.length - 1];
    if (first) this.setMedia(first.mediaKey);
    else if (this.root.querySelector('[data-scpc-media-root] [data-scpc-media-slide]')) {
      this.currentMediaKey = '__default';
      this.root.setAttribute('data-scpc-media-key', '__default');
      this.renderMediaNav();
      this.syncMediaNav();
    }
    else if (this.templateFor('__default') && this.templateFor('__default').content.querySelector('[data-scpc-media-slide]')) this.setMedia('__default');
    else {
      first = this.config.options.filter(function (option) {
        var template = option.mediaKey && self.templateFor(option.mediaKey);
        return option.changesMedia && template && template.content.querySelector('[data-scpc-media-slide]');
      })[0];
      if (first) this.setMedia(first.mediaKey);
    }
  };
  Configurator.prototype.syncMediaAfterState = function () {
    if (!this.currentMediaKey) { this.selectInitialMedia(); return; }
    var current = this.config.options.filter(function (option) { return option.mediaKey === this.currentMediaKey; }, this)[0];
    var currentQuantity = this.config.quantities.filter(function (quantity) { return quantity.changesMedia && quantity.mediaKey === this.currentMediaKey; }, this)[0];
    var quantityInactive = currentQuantity && (!(this.state.quantities[currentQuantity.key] || 0) || this.resolution.effects.hiddenQuantities[currentQuantity.id] || this.resolution.effects.hiddenSteps[currentQuantity.stepKey]);
    if ((current && !this.optionSelected(current, this.state.selections)) || quantityInactive) {
      var self = this;
      var fallback = this.config.options.filter(function (option) {
        var template = option.mediaKey && self.templateFor(option.mediaKey);
        return option.changesMedia && template && template.content.querySelector('[data-scpc-media-slide]') && self.optionSelected(option, self.state.selections);
      });
      if (fallback.length) this.setMedia(fallback[fallback.length - 1].mediaKey);
      else if (!this.restoreInitialMedia() && this.templateFor('__default') && this.templateFor('__default').content.querySelector('[data-scpc-media-slide]')) this.setMedia('__default');
    }
  };
  Configurator.prototype.setExpanded = function (expanded) {
    expanded = !!expanded;
    if (expanded === this.expanded) return;
    this.expanded = expanded;
    this.root.classList.toggle('is-media-expanded', expanded);
    var viewer = this.root.querySelector('[data-scpc-media-root]');
    if (viewer) viewer.classList.toggle('is-expanded', expanded);
    var viewerFrame = this.root.querySelector('[data-scpc-viewer]');
    if (viewerFrame) {
      viewerFrame.classList.toggle('is-expanded', expanded);
      viewerFrame.setAttribute('data-expanded', expanded ? 'true' : 'false');
    }
    var self = this;
    list(this.root.querySelectorAll('[data-scpc-expand], [data-scpc-media-expand]')).forEach(function (button) {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.setAttribute('aria-pressed', expanded ? 'true' : 'false');
      button.setAttribute('aria-label', expanded ? 'Close expanded media' : 'Expand media');
    });
    list(this.root.querySelectorAll('[data-scpc-expand-icon]')).forEach(function (icon) { icon.hidden = expanded; });
    list(this.root.querySelectorAll('[data-scpc-collapse-icon]')).forEach(function (icon) { icon.hidden = !expanded; });
    if (expanded) { this.expandFocus = document.activeElement; lockBody(); }
    else {
      unlockBody();
      if (this.expandFocus && this.expandFocus.focus) this.expandFocus.focus();
      this.expandFocus = null;
    }
    dispatch(this.root, 'sc-configurator:media-expand', { expanded: expanded, builderKey: self.config.builderKey });
  };

  Configurator.prototype.itemFromInfo = function (element) {
    var trigger = closest(element, '[data-scpc-info]', this.root);
    if (!trigger) return null;
    var key = trigger.getAttribute('data-scpc-info');
    var card = closest(trigger, '[data-scpc-option-card], [data-scpc-quantity]', this.root);
    return this.optionsById[trigger.getAttribute('data-option-id')] || this.quantitiesById[trigger.getAttribute('data-quantity-id')] ||
      (card && this.optionsById[card.getAttribute('data-option-id')]) || (card && this.quantitiesById[card.getAttribute('data-quantity-id')]) ||
      this.optionsById[key] || this.quantitiesById[key] || this.quantitiesByKey[key] || null;
  };
  Configurator.prototype.modalElements = function () {
    var modal = this.root.querySelector('[data-scpc-modal]');
    return {
      modal: modal,
      title: modal && modal.querySelector('[data-scpc-modal-title]'),
      body: modal && modal.querySelector('[data-scpc-modal-body]'),
      price: modal && modal.querySelector('[data-scpc-modal-price]'),
      media: modal && modal.querySelector('[data-scpc-modal-media]'),
      mediaNav: modal && modal.querySelector('[data-scpc-modal-media-nav]'),
      mediaPrev: modal && modal.querySelector('[data-scpc-modal-media-prev]'),
      mediaNext: modal && modal.querySelector('[data-scpc-modal-media-next]'),
      select: modal && modal.querySelector('[data-scpc-modal-select]')
    };
  };
  Configurator.prototype.renderModalMediaNav = function () {
    var elements = this.modalElements();
    var slides = list(elements.media && elements.media.querySelectorAll('[data-scpc-media-slide]'));
    if (elements.mediaNav) {
      clear(elements.mediaNav);
      slides.forEach(function (slide, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'scpc__media-dot scpc__modal-media-dot';
        button.setAttribute('data-scpc-modal-media-index', String(index));
        button.setAttribute('aria-label', 'View modal media ' + (index + 1) + ' of ' + slides.length);
        button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        elements.mediaNav.appendChild(button);
      });
      elements.mediaNav.hidden = slides.length < 2;
    }
    if (elements.mediaPrev) elements.mediaPrev.hidden = slides.length < 2;
    if (elements.mediaNext) elements.mediaNext.hidden = slides.length < 2;
    this.modalMediaIndex = 0;
    this.syncModalMediaNav();
  };
  Configurator.prototype.syncModalMediaNav = function () {
    var elements = this.modalElements();
    if (!elements.media) return;
    var slides = list(elements.media.querySelectorAll('[data-scpc-media-slide]'));
    var width = elements.media.clientWidth || 1;
    this.modalMediaIndex = Math.max(0, Math.min(slides.length - 1, Math.round(elements.media.scrollLeft / width)));
    if (elements.mediaNav) list(elements.mediaNav.querySelectorAll('[data-scpc-modal-media-index]')).forEach(function (button, index) {
      button.setAttribute('aria-current', index === this.modalMediaIndex ? 'true' : 'false');
    }, this);
    if (elements.mediaPrev) elements.mediaPrev.disabled = this.modalMediaIndex <= 0;
    if (elements.mediaNext) elements.mediaNext.disabled = this.modalMediaIndex >= slides.length - 1;
    slides.forEach(function (slide, index) {
      if (index !== this.modalMediaIndex) pauseVideos(slide);
      else list(slide.querySelectorAll('video[autoplay]')).forEach(function (video) {
        var promise;
        try { promise = video.play(); } catch (error) { promise = null; }
        if (promise && promise.catch) promise.catch(function () {});
      });
      slide.setAttribute('aria-hidden', index === this.modalMediaIndex ? 'false' : 'true');
      if ('inert' in slide) slide.inert = index !== this.modalMediaIndex;
    }, this);
  };
  Configurator.prototype.scrollModalMediaTo = function (index) {
    var elements = this.modalElements();
    if (!elements.media) return;
    var slides = list(elements.media.querySelectorAll('[data-scpc-media-slide]'));
    index = Math.max(0, Math.min(slides.length - 1, integer(index, 0)));
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { elements.media.scrollTo({ left: index * elements.media.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); }
    catch (error) { elements.media.scrollLeft = index * elements.media.clientWidth; }
  };
  Configurator.prototype.openModal = function (item, trigger) {
    var elements = this.modalElements();
    if (!item || !elements.modal) return;
    this.modalItem = item;
    this.modalFocus = trigger || document.activeElement;
    if (elements.title) elements.title.textContent = item.label;
    if (elements.body) {
      /* tooltipHtml is trusted HTML rendered by Liquid from the configured rich-text metafield. */
      elements.body.innerHTML = item.tooltipHtml || '';
      elements.body.hidden = !item.tooltipHtml;
    }
    var option = this.optionsById[item.id];
    var marginal = option ? this.hypotheticalOption(option) : this.hypotheticalQuantity(item);
    var selected = option ? this.optionSelected(option, this.state.selections) : (this.state.quantities[item.key] || 0) > 0;
    var quantityAtMax = !option && (this.state.quantities[item.key] || 0) >= item.max;
    if (elements.price) elements.price.textContent = this.formatDelta(quantityAtMax ? item.price : marginal.delta, marginal.resolution.valid, option ? selected : false);
    if (elements.media) {
      if (item.mediaKey) {
        var cloned = this.cloneMedia(item.mediaKey, elements.media);
        if (!cloned) { pauseVideos(elements.media); clear(elements.media); }
        elements.media.hidden = !cloned;
      }
      else { pauseVideos(elements.media); clear(elements.media); elements.media.hidden = true; }
    }
    this.renderModalMediaNav();
    if (elements.select) {
      var multiple = option && this.stepsByKey[option.stepKey] && this.stepsByKey[option.stepKey].type === 'multiple';
      var canAct = marginal.resolution.valid && !quantityAtMax && !(option && selected && !multiple);
      elements.select.textContent = option ? (selected ? (multiple ? 'Remove from my build' : 'Selected') : 'Add to my build') : (quantityAtMax ? 'Maximum added' : 'Add extra');
      elements.select.disabled = !canAct;
      elements.select.setAttribute('aria-disabled', canAct ? 'false' : 'true');
      elements.select.setAttribute('data-scpc-selected', selected ? 'true' : 'false');
    }
    elements.modal.hidden = false;
    elements.modal.setAttribute('aria-hidden', 'false');
    elements.modal.classList.add('is-open');
    this.modalOpen = true;
    lockBody();
    var backdrop = elements.modal.querySelector('[data-scpc-modal-backdrop], .scpc__modal-backdrop');
    if (backdrop) backdrop.setAttribute('tabindex', '-1');
    var closeButton = elements.modal.querySelector('[data-scpc-modal-close]:not([data-scpc-modal-backdrop]):not(.scpc__modal-backdrop)');
    var focusTarget = closeButton || elements.modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusTarget) focusTarget.focus();
  };
  Configurator.prototype.closeModal = function () {
    if (!this.modalOpen) return;
    var elements = this.modalElements();
    if (elements.modal) {
      pauseVideos(elements.modal);
      elements.modal.hidden = true;
      elements.modal.setAttribute('aria-hidden', 'true');
      elements.modal.classList.remove('is-open');
    }
    this.modalOpen = false;
    this.modalItem = null;
    unlockBody();
    if (this.modalFocus && this.modalFocus.focus) this.modalFocus.focus();
    this.modalFocus = null;
  };
  Configurator.prototype.trapModalFocus = function (event) {
    var modal = this.modalElements().modal;
    if (!this.modalOpen || !modal || event.key !== 'Tab') return;
    var focusable = list(modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return !matches(element, '[data-scpc-modal-backdrop], .scpc__modal-backdrop') && !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });
    if (!focusable.length) { event.preventDefault(); modal.focus(); return; }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  Configurator.prototype.selectModalItem = function () {
    var item = this.modalItem;
    this.closeModal();
    if (!item) return;
    if (this.optionsById[item.id]) this.chooseOption(item);
    else this.changeQuantity(item, 'increase');
  };

  Configurator.prototype.cartItems = function () {
    return this.resolution.lines.map(function (line) { return { id: line.id, quantity: line.quantity }; });
  };
  Configurator.prototype.cartDrawer = function () {
    return document.querySelector('cart-drawer, cart-notification, [data-cart-drawer]');
  };
  Configurator.prototype.addToCart = function () {
    var self = this;
    if (this.adding || !this.resolution.valid || (this.config.requireComplete && !this.resolution.complete) || !this.resolution.lines.length) return;
    this.adding = true;
    this.cartMessage = this.config.strings.adding;
    this.render();
    var drawer = this.config.cartAction === 'drawer' ? this.cartDrawer() : null;
    var payload = { items: this.cartItems() };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        payload.sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
        payload.sections_url = window.location.pathname;
      } catch (error) { /* Theme drawers do not all share the same API. */ }
    }
    fetch(this.config.cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Shopify could not add this build.');
        return data;
      });
    }).then(function (data) {
      self.adding = false;
      self.cartMessage = self.config.strings.added;
      // v75: attribution + analytics. Both are best-effort and must never
      // interfere with the add itself, hence the try/catch around each.
      try { self.stampBuildAttribute(); } catch (error) { /* attribution only */ }
      try { self.trackBuildAdded(data); } catch (error) { /* analytics only */ }
      dispatch(self.root, 'sc-configurator:cart-added', { builderKey: self.config.builderKey, response: data, build: self.detail() });
      dispatch(document, 'ajaxProduct:added', { source: 'sc-product-configurator', response: data, build: self.detail() });
      dispatch(document.documentElement, 'cart:refresh', { source: 'sc-product-configurator' });
      dispatch(document.documentElement, 'cart:updated', { source: 'sc-product-configurator', response: data });
      dispatch(document.documentElement, 'cart:change', { source: 'sc-product-configurator', response: data });
      if (self.config.cartAction === 'cart' && self.config.cartUrl) {
        window.location.assign(self.config.cartUrl);
        return;
      }
      if (self.config.cartAction === 'drawer') {
        var activeDrawer = drawer || self.cartDrawer();
        if (activeDrawer) {
          try {
            if (typeof activeDrawer.renderContents === 'function' && data.sections) activeDrawer.renderContents(data);
            else if (typeof activeDrawer.open === 'function') activeDrawer.open();
            activeDrawer.removeAttribute('hidden');
          } catch (error) { /* Event-based themes still receive the events below. */ }
          dispatch(activeDrawer, 'cart-drawer:open', { source: 'sc-product-configurator', response: data });
        }
        dispatch(document.documentElement, 'cart-drawer:open', { source: 'sc-product-configurator', response: data });
      }
      self.render();
    }).catch(function (error) {
      self.adding = false;
      self.cartMessage = error && error.message && error.message !== 'Shopify could not add this build.' ? error.message : self.config.strings.error;
      self.render();
    });
  };

  Configurator.prototype.fitSize = function (value) {
    var self = this;
    if (value == null) return null;
    if (typeof value === 'string') {
      var normal = value.toLowerCase().trim();
      if (normal === 's' || /\bsmall\b/.test(normal)) return 'small';
      if (normal === 'l' || /\blarge\b/.test(normal)) return 'large';
      return null;
    }
    if (typeof value === 'object') {
      var fields = ['size', 'fit', 'recommended_size', 'recommendedSize', 'cube_size', 'cubeSize', 'seed_cube_size', 'seedCubeSize', 'category', 'group'];
      for (var index = 0; index < fields.length; index += 1) {
        var size = self.fitSize(value[fields[index]]);
        if (size) return size;
      }
    }
    return null;
  };
  Configurator.prototype.jsonThreshold = function (data) {
    var sources = [data, data && data.config, data && data.meta, data && data.settings];
    var fields = ['weight_threshold', 'weightThreshold', 'threshold', 'weight_split', 'weightSplit', 'large_min_weight', 'largeMinWeight', 'large_min_grams', 'small_max_weight'];
    for (var outer = 0; outer < sources.length; outer += 1) {
      var source = sources[outer];
      if (!source || typeof source !== 'object') continue;
      for (var inner = 0; inner < fields.length; inner += 1) {
        var value = parseFloat(source[fields[inner]]);
        if (isFinite(value)) return value;
      }
    }
    return null;
  };
  Configurator.prototype.recordWeight = function (value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string' && value.trim() && isFinite(Number(value))) return Number(value);
    if (value && typeof value === 'object') {
      var fields = ['weight_g', 'weight', 'grams', 'average_weight', 'averageWeight', 'avg_weight', 'avgWeight'];
      for (var index = 0; index < fields.length; index += 1) {
        var weight = parseFloat(value[fields[index]]);
        if (isFinite(weight)) return weight;
      }
    }
    return null;
  };
  Configurator.prototype.addBreed = function (name, size, borderline) {
    name = text(name).trim();
    size = this.fitSize(size);
    if (!name || !size) return;
    var key = name.toLowerCase();
    this.matcherData.species[key] = { name: name, size: size, borderline: borderline === true };
    if (!this.matcherData.seen[key]) {
      this.matcherData.seen[key] = true;
      this.matcherData.breeds.push({ name: name, size: size, borderline: borderline === true });
    }
  };
  Configurator.prototype.addSpeciesRecord = function (name, value, forcedSize, threshold) {
    var display = name;
    if (value && typeof value === 'object') display = value.name || value.species || value.common_name || value.commonName || value.title || name;
    var size = this.fitSize(forcedSize) || this.fitSize(value);
    var weight = this.recordWeight(value);
    if (!size && threshold != null && weight != null) size = weight > threshold ? 'large' : 'small';
    this.addBreed(display, size, !!(value && typeof value === 'object' && value.borderline === true));
  };
  Configurator.prototype.addSpeciesGroup = function (group, size, threshold) {
    var self = this;
    if (Array.isArray(group)) group.forEach(function (value, index) {
      if (typeof value === 'string') self.addBreed(value, size, false);
      else self.addSpeciesRecord(value && value.name || String(index), value, size, threshold);
    });
    else if (group && typeof group === 'object') Object.keys(group).forEach(function (name) { self.addSpeciesRecord(name, group[name], size, threshold); });
  };
  Configurator.prototype.addSpeciesData = function (data) {
    if (!data) return;
    var self = this;
    var threshold = this.jsonThreshold(data);
    if (threshold == null) threshold = 150;
    var source = data.species || data.birds || data.items || data;
    var grouped = data.sizes && typeof data.sizes === 'object' ? data.sizes : (source.sizes && typeof source.sizes === 'object' ? source.sizes : source);
    var hasGroups = grouped && typeof grouped === 'object' && (grouped.small != null || grouped.large != null);
    if (hasGroups) { this.addSpeciesGroup(grouped.small, 'small', threshold); this.addSpeciesGroup(grouped.large, 'large', threshold); }
    if (Array.isArray(source)) source.forEach(function (value, index) { self.addSpeciesRecord(value && value.name || String(index), value, null, threshold); });
    else if (source && typeof source === 'object' && !hasGroups) {
      var meta = ['config', 'meta', 'settings', 'threshold', 'weight_threshold', 'weightThreshold', 'weight_split', 'weightSplit', 'large_min_weight', 'largeMinWeight', 'large_min_grams', 'small_max_weight', 'sizes'];
      Object.keys(source).forEach(function (name) { if (meta.indexOf(name) < 0) self.addSpeciesRecord(name, source[name], null, threshold); });
    }
  };
  Configurator.prototype.addAlias = function (alias, value) {
    alias = text(alias).trim();
    if (!alias) return;
    var canonical = typeof value === 'string' ? value : value && (value.canonical || value.target || value.species || value.name);
    canonical = text(canonical).trim();
    if (canonical) this.matcherData.aliases[alias.toLowerCase()] = canonical.toLowerCase();
  };
  Configurator.prototype.addAliasData = function (data) {
    if (!data) return;
    var self = this;
    var source = data.aliases || data;
    if (Array.isArray(source)) source.forEach(function (value) { if (value) self.addAlias(value.alias || value.name, value); });
    else if (typeof source === 'object') Object.keys(source).forEach(function (alias) { self.addAlias(alias, source[alias]); });
  };
  Configurator.prototype.loadMatcher = function () {
    var self = this;
    var matcher = this.config.matcher;
    var wrapper = this.root.querySelector('[data-scpc-matcher]');
    if (wrapper) wrapper.hidden = !matcher.enabled;
    if (!matcher.enabled) return;
    if (!matcher.speciesUrl) { this.runtimeIssue('The recommendation matcher is enabled but has no species JSON asset.'); return; }
    Promise.all([
      fetch(matcher.speciesUrl, { credentials: 'same-origin' }).then(function (response) { if (!response.ok) throw new Error('Species JSON returned ' + response.status + '.'); return response.json(); }),
      matcher.aliasesUrl ? fetch(matcher.aliasesUrl, { credentials: 'same-origin' }).then(function (response) { return response.ok ? response.json() : {}; }).catch(function () { return {}; }) : Promise.resolve({})
    ]).then(function (files) {
      if (self.destroyed) return;
      self.matcherData = { breeds: [], species: {}, aliases: {}, seen: {} };
      self.addSpeciesData(files[0]);
      self.addAliasData(files[1]);
      self.matcherData.breeds.sort(function (left, right) { return left.name.localeCompare(right.name); });
      if (!self.matcherData.breeds.length) self.runtimeIssue('No usable species were found in the recommendation JSON.');
      else if (self.matcherElements().input && self.matcherElements().input.value.trim()) self.renderMatcherList();
    }).catch(function (error) { if (!self.destroyed) self.runtimeIssue('The recommendation matcher could not load: ' + error.message); });
  };
  Configurator.prototype.matcherElements = function () {
    return {
      input: this.root.querySelector('[data-scpc-matcher-input]'),
      list: this.root.querySelector('[data-scpc-matcher-list]'),
      result: this.root.querySelector('[data-scpc-matcher-result]')
    };
  };
  Configurator.prototype.matcherMatches = function (query) {
    var self = this;
    query = text(query).trim().toLowerCase();
    if (!query) return [];
    var starts = [];
    var contains = [];
    var seen = {};
    function queue(breed, atStart) {
      if (!breed || seen[breed.name.toLowerCase()]) return;
      seen[breed.name.toLowerCase()] = true;
      (atStart ? starts : contains).push(breed);
    }
    this.matcherData.breeds.forEach(function (breed) {
      var position = breed.name.toLowerCase().indexOf(query);
      if (position >= 0) queue(breed, position === 0);
    });
    Object.keys(this.matcherData.aliases).forEach(function (alias) {
      var position = alias.indexOf(query);
      if (position < 0) return;
      var canonical = self.matcherData.aliases[alias];
      queue(self.matcherData.species[canonical], position === 0);
    });
    return starts.concat(contains).slice(0, 8);
  };
  Configurator.prototype.renderMatcherList = function () {
    var self = this;
    var elements = this.matcherElements();
    if (!elements.input || !elements.list) return;
    var results = this.matcherMatches(elements.input.value);
    elements.input.removeAttribute('aria-activedescendant');
    clear(elements.list);
    results.forEach(function (breed, index) {
      var button = document.createElement('button');
      var name = document.createElement('span');
      var fit = document.createElement('small');
      button.type = 'button';
      button.className = 'scpc__matcher-choice';
      button.id = self.config.builderKey + '-' + self.config.sectionId + '-matcher-' + index;
      button.setAttribute('role', 'option');
      button.setAttribute('data-scpc-matcher-choice', breed.name);
      button.setAttribute('data-scpc-matcher-size', breed.size);
      name.textContent = breed.name;
      fit.className = 'scpc__matcher-fit';
      fit.textContent = breed.size.charAt(0).toUpperCase() + breed.size.slice(1) + ' fit';
      button.appendChild(name);
      button.appendChild(fit);
      elements.list.appendChild(button);
    });
    elements.list.hidden = !results.length;
    elements.input.setAttribute('aria-expanded', results.length ? 'true' : 'false');
  };
  Configurator.prototype.matchSpecies = function (name) {
    var query = text(name).trim().toLowerCase();
    if (this.matcherData.aliases[query]) query = this.matcherData.aliases[query];
    return this.matcherData.species[query] || null;
  };
  Configurator.prototype.matcherMessage = function (breed) {
    var before = this.config.matcher.beforeSpecies.trim();
    var after = this.config.matcher.afterSpecies;
    var gapBefore = before ? ' ' : '';
    var gapAfter = after && !/^[,.;:!?)]/.test(after.replace(/^\s+/, '')) ? ' ' : '';
    return before + gapBefore + breed.name + gapAfter + after;
  };
  Configurator.prototype.appendMatcherLine = function (container, className, value) {
    value = text(value).trim();
    if (!container || !value) return null;
    var line = document.createElement('p');
    line.className = className;
    line.textContent = value;
    container.appendChild(line);
    return line;
  };
  Configurator.prototype.appendMatcherSupport = function (container) {
    if (!container) return;
    var copy = this.config.matcher.secondOpinionText.trim();
    var label = this.config.matcher.teamLinkLabel.trim();
    var href = this.config.matcher.teamLinkUrl;
    if (!copy && (!label || !href)) return;
    var support = document.createElement('p');
    support.className = 'scpc__matcher-support';
    if (copy) support.appendChild(document.createTextNode(copy));
    if (label && href) {
      if (copy) support.appendChild(document.createTextNode(' '));
      var link = document.createElement('a');
      link.href = href;
      link.textContent = label;
      support.appendChild(link);
    }
    container.appendChild(support);
  };
  Configurator.prototype.applySpecies = function (name, sizeHint) {
    var elements = this.matcherElements();
    var breed = this.matchSpecies(name);
    if (!breed && sizeHint) breed = { name: name, size: sizeHint, borderline: false };
    if (elements.list) elements.list.hidden = true;
    if (elements.input) {
      elements.input.setAttribute('aria-expanded', 'false');
      elements.input.removeAttribute('aria-activedescendant');
    }
    if (!breed) {
      this.recommended = null;
      if (elements.result) {
        clear(elements.result);
        this.appendMatcherLine(elements.result, 'scpc__matcher-unknown', this.config.matcher.unknownText);
        this.appendMatcherSupport(elements.result);
        elements.result.hidden = false;
      }
      this.renderOptions();
      return;
    }
    var target = this.config.options.filter(function (option) { return option.stepKey === this.config.matcher.targetStep && sameValue(option.value, breed.size); }, this)[0];
    this.recommended = target ? { optionId: target.id, species: breed.name, size: breed.size } : null;
    if (elements.input) elements.input.value = breed.name;
    if (elements.result) {
      var before = this.config.matcher.beforeSpecies.trim();
      var after = this.config.matcher.afterSpecies;
      var introduction = document.createElement('p');
      var strong = document.createElement('strong');
      clear(elements.result);
      introduction.className = 'scpc__matcher-introduction';
      if (before) introduction.appendChild(document.createTextNode(before + ' '));
      strong.textContent = breed.name;
      introduction.appendChild(strong);
      if (after) introduction.appendChild(document.createTextNode((/^[,.;:!?)]/.test(after.replace(/^\s+/, '')) ? '' : ' ') + after));
      elements.result.appendChild(introduction);
      if (target) {
        var fit = document.createElement('p');
        var fitStrong = document.createElement('strong');
        fit.className = 'scpc__matcher-recommendation';
        var fitLabel = this.config.matcher.fitLabel.trim();
        if (fitLabel) fit.appendChild(document.createTextNode(fitLabel + (/[:;,.!?]\s*$/.test(fitLabel) ? ' ' : ': ')));
        fitStrong.textContent = target.label;
        fit.appendChild(fitStrong);
        fit.appendChild(document.createTextNode('.'));
        elements.result.appendChild(fit);
      }
      this.appendMatcherLine(elements.result, 'scpc__matcher-reason', breed.size === 'large' ? this.config.matcher.largeReason : this.config.matcher.smallReason);
      if (breed.borderline) this.appendMatcherLine(elements.result, 'scpc__matcher-borderline', this.config.matcher.borderlineText);
      this.appendMatcherSupport(elements.result);
      elements.result.hidden = false;
    }
    if (target && this.config.matcher.autoSelect) {
      this.lastChoiceId = target.id;
      this.setOptionState(target, true, this.state.selections);
      if (target.changesMedia && target.mediaKey) this.setMedia(target.mediaKey);
      this.update(target.stepKey);
      var step = this.stepsByKey[target.stepKey];
      if (this.config.autoAdvance && step && step.autoAdvance) this.advanceFrom(step.key);
    } else this.renderOptions();
  };

  Configurator.prototype.bind = function () {
    var self = this;
    var mediaRoot = this.root.querySelector('[data-scpc-media-root]');
    if (mediaRoot) this.listen(mediaRoot, 'scroll', function () {
      if (self.mediaFrame) window.cancelAnimationFrame(self.mediaFrame);
      self.mediaFrame = window.requestAnimationFrame(function () { self.mediaFrame = 0; self.syncMediaNav(); });
    }, { passive: true });
    var modalMedia = this.root.querySelector('[data-scpc-modal-media]');
    if (modalMedia) this.listen(modalMedia, 'scroll', function () {
      if (self.modalMediaFrame) window.cancelAnimationFrame(self.modalMediaFrame);
      self.modalMediaFrame = window.requestAnimationFrame(function () { self.modalMediaFrame = 0; self.syncModalMediaNav(); });
    }, { passive: true });
    this.listen(this.root, 'click', function (event) {
      var closeButton = closest(event.target, '[data-scpc-modal-close]', self.root);
      if (closeButton) { event.preventDefault(); self.closeModal(); return; }
      var modal = closest(event.target, '[data-scpc-modal]', self.root);
      if (modal && (event.target === modal || matches(event.target, '[data-scpc-modal-backdrop]'))) { self.closeModal(); return; }
      if (closest(event.target, '[data-scpc-modal-select]', self.root)) { event.preventDefault(); self.selectModalItem(); return; }
      var info = closest(event.target, '[data-scpc-info]', self.root);
      if (info) { event.preventDefault(); event.stopPropagation(); self.openModal(self.itemFromInfo(info), info); return; }
      var expand = closest(event.target, '[data-scpc-expand], [data-scpc-media-expand]', self.root);
      if (expand) { event.preventDefault(); self.setExpanded(!self.expanded); return; }
      var mediaDot = closest(event.target, '[data-scpc-media-index]', self.root);
      if (mediaDot) { event.preventDefault(); self.scrollMediaTo(mediaDot.getAttribute('data-scpc-media-index')); return; }
      var modalMediaDot = closest(event.target, '[data-scpc-modal-media-index]', self.root);
      if (modalMediaDot) { event.preventDefault(); self.scrollModalMediaTo(modalMediaDot.getAttribute('data-scpc-modal-media-index')); return; }
      if (closest(event.target, '[data-scpc-modal-media-prev]', self.root)) { event.preventDefault(); self.scrollModalMediaTo(self.modalMediaIndex - 1); return; }
      if (closest(event.target, '[data-scpc-modal-media-next]', self.root)) { event.preventDefault(); self.scrollModalMediaTo(self.modalMediaIndex + 1); return; }
      if (closest(event.target, '[data-scpc-review-close]', self.root)) {
        event.preventDefault();
        self.reviewOpen = false;
        self.renderReview();
        var reviewTrigger = self.reviewFocus || self.root.querySelector('[data-scpc-review-toggle]');
        if (reviewTrigger && reviewTrigger.focus) reviewTrigger.focus();
        self.reviewFocus = null;
        return;
      }
      var review = closest(event.target, '[data-scpc-review-toggle]', self.root);
      if (review) {
        event.preventDefault();
        self.reviewOpen = !self.reviewOpen;
        self.reviewFocus = self.reviewOpen ? review : null;
        self.renderReview();
        return;
      }
      if (closest(event.target, '[data-scpc-add]', self.root)) {
        event.preventDefault();
        if (self.canAddNow()) self.addToCart();
        else { var guideStep = self.firstIncompleteStep(); if (guideStep) self.openStepForGuide(guideStep.key); }
        return;
      }
      var choice = closest(event.target, '[data-scpc-matcher-choice]', self.root);
      if (choice) { event.preventDefault(); self.applySpecies(choice.getAttribute('data-scpc-matcher-choice'), choice.getAttribute('data-scpc-matcher-size')); return; }
      var stepToggle = closest(event.target, '[data-scpc-step-toggle]', self.root);
      if (stepToggle) {
        event.preventDefault();
        var stepElement = closest(stepToggle, '[data-scpc-step]', self.root);
        var stepKey = stepElement ? stepElement.getAttribute('data-scpc-step') : stepToggle.getAttribute('data-scpc-step-toggle');
        if (stepKey) self.openStep(stepKey, true);
        return;
      }
      var plus = closest(event.target, '[data-scpc-quantity-plus]', self.root);
      if (plus) { event.preventDefault(); self.changeQuantity(self.findQuantity(plus), 'increase'); return; }
      var minus = closest(event.target, '[data-scpc-quantity-minus]', self.root);
      if (minus) { event.preventDefault(); self.changeQuantity(self.findQuantity(minus), 'decrease'); return; }
      var option = self.findOption(event.target);
      if (option) { event.preventDefault(); self.chooseOption(option); }
    });
    this.listen(this.root, 'change', function (event) {
      var input = closest(event.target, '[data-scpc-quantity-input]', self.root);
      if (input) self.changeQuantity(self.findQuantity(input), input.value);
    });
    this.listen(this.root, 'input', function (event) {
      if (!matches(event.target, '[data-scpc-matcher-input]')) return;
      self.recommended = null;
      var result = self.matcherElements().result;
      if (result) result.hidden = true;
      self.renderMatcherList();
      self.renderOptions();
      if (self.resolution) self.renderContextAndProgress();
    });
    this.listen(this.root, 'focusin', function (event) {
      if (matches(event.target, '[data-scpc-matcher-input]')) self.renderMatcherList();
    });
    this.listen(this.root, 'keydown', function (event) {
      self.trapModalFocus(event);
      if (event.key === 'Escape') {
        if (self.modalOpen) { event.preventDefault(); self.closeModal(); }
        else if (self.expanded) { event.preventDefault(); self.setExpanded(false); }
        else {
          var matcherList = self.matcherElements().list;
          if (matcherList) matcherList.hidden = true;
          var matcherInput = self.matcherElements().input;
          if (matcherInput) {
            matcherInput.setAttribute('aria-expanded', 'false');
            matcherInput.removeAttribute('aria-activedescendant');
          }
        }
      }
      if (self.handleOptionArrow(event)) return;
      if (!matches(event.target, '[data-scpc-matcher-input]')) return;
      var elements = self.matcherElements();
      var choices = list(elements.list && elements.list.querySelectorAll('[data-scpc-matcher-choice]'));
      if (event.key === 'Enter') {
        event.preventDefault();
        var focused = elements.list && elements.list.querySelector('[aria-selected="true"]');
        if (focused || choices[0]) (focused || choices[0]).click();
        else if (event.target.value.trim()) self.applySpecies(event.target.value.trim());
      } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && choices.length) {
        event.preventDefault();
        var current = choices.map(function (choice) { return choice.getAttribute('aria-selected'); }).indexOf('true');
        current = event.key === 'ArrowDown' ? Math.min(choices.length - 1, current + 1) : Math.max(0, current < 0 ? 0 : current - 1);
        choices.forEach(function (choice, index) { choice.setAttribute('aria-selected', index === current ? 'true' : 'false'); });
        event.target.setAttribute('aria-activedescendant', choices[current].id);
      }
    });
    this.listen(document, 'click', function (event) {
      var matcher = self.root.querySelector('[data-scpc-matcher]');
      if (matcher && !matcher.contains(event.target)) {
        var elements = self.matcherElements();
        if (elements.list) elements.list.hidden = true;
        if (elements.input) {
          elements.input.setAttribute('aria-expanded', 'false');
          elements.input.removeAttribute('aria-activedescendant');
        }
      }
    });
    this.listen(document, 'keydown', function (event) {
      if (event.defaultPrevented || event.key !== 'Escape') return;
      if (self.modalOpen) { event.preventDefault(); self.closeModal(); }
      else if (self.expanded) { event.preventDefault(); self.setExpanded(false); }
    });
    // Flag the body while the purchase bar is on screen; mobile CSS hides the chat widget.
    var purchaseBar = this.root.querySelector('[data-scpc-purchase-bar]');
    if (purchaseBar && 'IntersectionObserver' in window) {
      var barObserver = new IntersectionObserver(function (entries) {
        for (var entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
          document.body.classList.toggle('scpc-purchase-visible', entries[entryIndex].isIntersecting);
        }
      }, { threshold: 0.05 });
      barObserver.observe(purchaseBar);
      this.cleanups.push(function () {
        barObserver.disconnect();
        document.body.classList.remove('scpc-purchase-visible');
      });
      // Float the bar once the whole builder has been scrolled past.
      var sectionObserver = new IntersectionObserver(function (entries) {
        for (var sectionIndex = 0; sectionIndex < entries.length; sectionIndex += 1) {
          var entry = entries[sectionIndex];
          self.setFloatingBar(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        }
      }, { threshold: 0 });
      sectionObserver.observe(this.root);
      this.cleanups.push(function () {
        sectionObserver.disconnect();
        self.setFloatingBar(false);
      });
    }
  };
  Configurator.prototype.listen = function (target, name, handler, options) {
    target.addEventListener(name, handler, options || false);
    this.cleanups.push(function () { target.removeEventListener(name, handler, options || false); });
  };

  Configurator.prototype.validate = function () {
    var self = this;
    var seenSteps = {};
    var seenOptions = {};
    var seenOptionValues = {};
    var seenQuantities = {};
    var signatures = {};
    this.config.steps.forEach(function (step) {
      if (!step.key) { self.issues.push('A step is missing its key.'); self.hasFatalConfig = true; }
      else if (seenSteps[step.key]) { self.issues.push('Duplicate step key: ' + step.key + '.'); self.hasFatalConfig = true; }
      seenSteps[step.key] = true;
      if (!(self.optionsByStep[step.key] || []).length && !(self.quantitiesByStep[step.key] || []).length) self.issues.push('Step "' + step.label + '" has no options or quantity add-ons.');
    });
    this.config.options.forEach(function (option) {
      if (seenOptions[option.id]) { self.issues.push('Duplicate option ID: ' + option.id + '.'); self.hasFatalConfig = true; }
      seenOptions[option.id] = true;
      var optionValueKey = option.stepKey + ' ' + option.value;
      if (seenOptionValues[optionValueKey]) { self.issues.push('Step "' + option.stepKey + '" contains duplicate option value "' + option.value + '". Duplicate values block cart resolution.'); self.hasFatalConfig = true; }
      seenOptionValues[optionValueKey] = true;
      if (!self.stepsByKey[option.stepKey]) { self.issues.push('Option "' + option.label + '" points to missing step "' + option.stepKey + '".'); self.hasFatalConfig = true; }
      if (option.condition && option.condition.key && !self.stepsByKey[option.condition.key] && !self.quantitiesByKey[option.condition.key] && !self.quantitiesById[option.condition.key] && !self.optionsById[option.condition.key]) {
        self.issues.push('Option "' + option.label + '" has a condition whose source was not found: "' + option.condition.key + '".');
        self.hasFatalConfig = true;
      }
      if (option.variantSkuRequested && option.variantSkuMatches === 0) {
        self.issues.push('Option "' + option.label + '" requests SKU "' + option.variantSkuRequested + '", but that SKU was not found on its selected product.');
        self.hasFatalConfig = true;
      } else if (option.variantSkuRequested && option.variantSkuMatches > 1) {
        self.issues.push('Option "' + option.label + '" requests SKU "' + option.variantSkuRequested + '", but more than one product variant uses it. Make the SKU unique; no variant will be added until this is corrected.');
        self.hasFatalConfig = true;
      } else if (!option.variantSkuRequested && option.productVariantCount > 1) {
        self.issues.push('Option "' + option.label + '" uses a product with ' + option.productVariantCount + ' variants and no exact SKU. Its selected or first available variant is being used. Add an exact SKU if that is not intentional.');
      }
      if (option.includeInSignature && option.addSeparately) self.issues.push('Option "' + option.label + '" is both a bundle token and a separate add-on. Confirm that this is intentional.');
      if (option.addSeparately && !validVariant(option.variantId)) self.issues.push('Separate add-on "' + option.label + '" has no product variant.');
      if (self.config.fallbackMode === 'individual' && !validVariant(option.variantId) && !option.noFallbackProduct) self.issues.push('Option "' + option.label + '" needs an individual fallback product or the intentional no-product toggle.');
      if (option.changesMedia && (!self.templateFor(option.mediaKey) || !self.templateFor(option.mediaKey).content.querySelector('[data-scpc-media-slide]'))) self.issues.push('Option "' + option.label + '" changes media but has no usable media.');
    });
    this.config.steps.filter(function (step) { return step.type === 'single'; }).forEach(function (step) {
      var defaults = (self.optionsByStep[step.key] || []).filter(function (option) { return option.defaultSelected; });
      if (defaults.length > 1) self.issues.push('Single-choice step "' + step.label + '" has more than one default; only the first is used.');
    });
    this.config.quantities.forEach(function (item) {
      if (seenQuantities[item.key]) { self.issues.push('Duplicate quantity key: ' + item.key + '.'); self.hasFatalConfig = true; }
      seenQuantities[item.key] = true;
      if (!self.stepsByKey[item.stepKey]) { self.issues.push('Quantity "' + item.label + '" points to missing step "' + item.stepKey + '".'); self.hasFatalConfig = true; }
      if (item.variantSkuRequested && item.variantSkuMatches === 0) {
        self.issues.push('Quantity "' + item.label + '" requests SKU "' + item.variantSkuRequested + '", but that SKU was not found on its selected product.');
        self.hasFatalConfig = true;
      } else if (item.variantSkuRequested && item.variantSkuMatches > 1) {
        self.issues.push('Quantity "' + item.label + '" requests SKU "' + item.variantSkuRequested + '", but more than one product variant uses it. Make the SKU unique; no variant will be added until this is corrected.');
        self.hasFatalConfig = true;
      } else if (!item.variantSkuRequested && item.productVariantCount > 1) {
        self.issues.push('Quantity "' + item.label + '" uses a product with ' + item.productVariantCount + ' variants and no exact SKU. Its selected or first available variant is being used. Add an exact SKU if that is not intentional.');
      }
      if (!validVariant(item.variantId)) self.issues.push('Quantity "' + item.label + '" has no product variant.');
      if (item.changesMedia && (!self.templateFor(item.mediaKey) || !self.templateFor(item.mediaKey).content.querySelector('[data-scpc-media-slide]'))) self.issues.push('Quantity "' + item.label + '" changes media but has no usable media.');
    });
    this.config.bundles.forEach(function (bundle) {
      if (!bundle.signature) self.issues.push('Bundle "' + bundle.title + '" has no configurator signature.');
      if (!validVariant(bundle.variantId)) self.issues.push('Bundle "' + bundle.title + '" has no available variant ID.');
      if (bundle.signature) {
        if (signatures[bundle.signature]) self.issues.push('Multiple bundle products use signature "' + bundle.signature + '". Priority, then lowest price, will decide.');
        signatures[bundle.signature] = true;
      }
    });
    if (this.config.options.some(function (option) { return option.includeInSignature; }) && !this.config.bundles.length) this.issues.push('Bundle-matching options exist, but the bundle product pool is empty.');
    if (this.config.matcher.enabled && !this.stepsByKey[this.config.matcher.targetStep]) this.issues.push('The matcher target step "' + this.config.matcher.targetStep + '" does not exist.');
    if (this.config.connectedValueKey && !this.stepsByKey[this.config.connectedValueKey] && !this.quantitiesByKey[this.config.connectedValueKey]) this.issues.push('Connected value key "' + this.config.connectedValueKey + '" does not match a step or quantity.');
    this.config.rules.forEach(function (rule) {
      var targets = rule.targetType === 'step' ? (self.stepsByKey[rule.targetKey] ? [self.stepsByKey[rule.targetKey]] : []) : (rule.targetType === 'quantity' ? self.targetQuantities(rule.targetKey) : self.targetOptions(rule.targetKey));
      if (!rule.whenKey) { self.issues.push('A conditional rule has no source key.'); self.hasFatalConfig = true; }
      else if (!self.stepsByKey[rule.whenKey] && !self.quantitiesByKey[rule.whenKey] && !self.quantitiesById[rule.whenKey] && !self.optionsById[rule.whenKey]) {
        self.issues.push('Conditional rule source not found: "' + rule.whenKey + '".');
        self.hasFatalConfig = true;
      }
      if (!targets.length) { self.issues.push('Conditional rule target not found: ' + rule.targetType + ' "' + rule.targetKey + '".'); self.hasFatalConfig = true; }
    });
    var modal = this.root.querySelector('[data-scpc-modal]');
    if (this.config.options.some(function (option) { return !!option.tooltipHtml; }) || this.config.quantities.some(function (item) { return !!item.tooltipHtml; })) {
      if (!modal) this.issues.push('Tooltip content exists, but the accessible modal is missing.');
      else if (!modal.querySelector('[data-scpc-modal-close]:not([data-scpc-modal-backdrop]):not(.scpc__modal-backdrop)')) this.issues.push('The tooltip modal is missing its visible X close button.');
    }
    this.renderDiagnostics();
  };
  Configurator.prototype.runtimeIssue = function (message) {
    if (this.issues.indexOf(message) < 0) this.issues.push(message);
    if (window.console && console.warn) console.warn('[SC Product Configurator] ' + message, this.root);
    this.renderDiagnostics();
  };
  Configurator.prototype.renderDiagnostics = function () {
    if (!this.root) return;
    var container = this.root.querySelector('[data-scpc-diagnostics]');
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var messages = this.issues.slice();
    var resolution = this.resolution;
    function addMessage(message) {
      if (message && messages.indexOf(message) < 0) messages.push(message);
    }
    if (resolution && resolution.signature && !resolution.pending) {
      if (!resolution.bundle && resolution.exactMatches === 0) {
        addMessage('Current build signature "' + resolution.signature + '" has no exact bundle match. Bundle pricing and savings cannot be shown until the product signature matches exactly.');
      } else if (!resolution.bundle && resolution.exactMatches > 0 && resolution.availableExactMatches === 0) {
        addMessage('The current build matches ' + resolution.exactMatches + ' bundle candidate' + (resolution.exactMatches === 1 ? '' : 's') + ', but none is available in this market.');
      } else if (resolution.bundle && !resolution.bundleReferenceComplete) {
        addMessage('Bundle "' + resolution.bundle.title + '" matched, but its regular individual value could not be verified' + (resolution.bundleReferenceMissing.length ? ' because these choices need a standalone product or the intentional no-product toggle: ' + resolution.bundleReferenceMissing.join(', ') : '') + '.');
      } else if (resolution.bundle && resolution.savings <= 0) {
        addMessage('Bundle "' + resolution.bundle.title + '" matched, but its price is not below the verified regular value, so no savings claim is shown.');
      }
    }
    this.root.setAttribute('data-scpc-diagnostic-count', String(messages.length));
    if (!container) return;
    container.hidden = !designMode || !messages.length;
    clear(container);
    if (!designMode) return;
    var listElement = document.createElement('ul');
    messages.forEach(function (issue) {
      var item = document.createElement('li');
      item.textContent = issue;
      listElement.appendChild(item);
    });
    container.appendChild(listElement);
  };

  Configurator.prototype.destroy = function () {
    if (this.destroyed) return;
    this.destroyed = true;
    this.closeModal();
    if (this.expanded) this.setExpanded(false);
    pauseVideos(this.root);
    if (this.mediaFrame) window.cancelAnimationFrame(this.mediaFrame);
    if (this.modalMediaFrame) window.cancelAnimationFrame(this.modalMediaFrame);
    this.cleanups.forEach(function (cleanup) { cleanup(); });
    this.cleanups = [];
    this.root.removeAttribute('data-scpc-initialized');
    this.root.__scpcInstance = null;
  };

  function rootsIn(scope) {
    var roots = [];
    if (scope && scope.nodeType === 1 && matches(scope, '[data-sc-configurator]')) roots.push(scope);
    return roots.concat(list((scope || document).querySelectorAll ? (scope || document).querySelectorAll('[data-sc-configurator]') : []));
  }
  function init(root) {
    if (!root || root.__scpcInstance) return root && root.__scpcInstance;
    var instance;
    try { instance = new Configurator(root); }
    catch (error) {
      root.__scpcInstance = null;
      root.setAttribute('data-scpc-initialization-error', 'true');
      if (window.console && console.error) console.error('[SC Product Configurator] Initialization failed.', error, root);
      return null;
    }
    if (!instance.config) return null;
    root.__scpcInstance = instance;
    return instance;
  }
  /* ---- SC builder extensions: theme money format, real Twin Pack substitution,
     shared cart reward bar, media thumbnails, extras compare-at. ---- */

  Configurator.prototype.formatMoney = function (value) {
    var amount = integer(value, 0);
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      try { return theme.Currency.formatMoney(amount, theme.settings.moneyFormat); } catch (error) {}
    }
    var units = amount / 100;
    try { return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(units); }
    catch (error) { return this.config.currency + ' ' + units.toFixed(2); }
  };

  /* Swap pairs of a single add-on for the real Twin Pack variant, so the cart
     receives the actual bundle product rather than two discounted singles. */
  Configurator.prototype.applyPairSubstitution = function (solution) {
    if (!solution || !Array.isArray(solution.lines) || !solution.lines.length) return;
    var extras = [];
    this.config.quantities.forEach(function (item) {
      if (!validVariant(item.pairVariantId) || item.pairAvailable === false) return;
      var pairPrice = cents(item.pairPrice);
      var unitPrice = cents(item.price);
      if (pairPrice <= 0 || unitPrice <= 0 || !validVariant(item.variantId)) return;
      for (var i = 0; i < solution.lines.length; i++) {
        var line = solution.lines[i];
        if (line.source !== 'quantity' || line.id !== item.variantId) continue;
        if (line.quantity < 2) break;
        var pairs = Math.floor(line.quantity / 2);
        var remainder = line.quantity % 2;
        extras.push({
          id: integer(item.pairVariantId, 0),
          quantity: pairs,
          price: pairPrice,
          compareAt: unitPrice * 2,
          label: text(item.pairLabel) || (text(line.label) + ' twin pack'),
          source: 'quantity',
          order: line.order
        });
        if (remainder > 0) line.quantity = remainder;
        else solution.lines.splice(i, 1);
        break;
      }
    });
    if (!extras.length) return;
    extras.forEach(function (extra) { solution.lines.push(extra); });
    solution.lines.sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
    var total = solution.lines.reduce(function (sum, line) { return sum + cents(line.price) * line.quantity; }, 0);
    solution.total = total;
    solution.compareAtTotal = Math.max(total, cents(solution.referenceTotal));
    solution.savings = Math.max(0, solution.compareAtTotal - total);
  };

  var scpcBaseResolve = Configurator.prototype.resolve;
  Configurator.prototype.resolve = function (selections, quantities) {
    var solution = scpcBaseResolve.call(this, selections, quantities);
    try { this.applyPairSubstitution(solution); } catch (error) {}
    return solution;
  };

  /* ---- Shared cart reward bar ---- */

  Configurator.prototype.rewardBarEl = function () {
    return this.root.querySelector('[data-scpc-rewards] [data-sc-reward-bar]');
  };

  /* True when every line of the current build is already sitting in the cart,
     in which case the build must not be counted again on top of it. */
  Configurator.prototype.cartContainsBuild = function (cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    if (!this.resolution || !Array.isArray(this.resolution.lines) || !this.resolution.lines.length) return false;
    var counts = {};
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      if (props._sc_threshold_gift === 'true') return;
      counts[item.variant_id] = (counts[item.variant_id] || 0) + (item.quantity || 0);
    });
    return this.resolution.lines.every(function (line) {
      return (counts[line.id] || 0) >= line.quantity;
    });
  };

  Configurator.prototype.syncRewardBar = function () {
    var bar = this.rewardBarEl();
    if (!bar) return;
    var counts = this.resolution && this.resolution.valid && !this.cartContainsBuild(this.scRewardCart);
    var offset = counts ? integer(this.resolution.total, 0) : 0;
    var current = integer(bar.getAttribute('data-sc-reward-offset-cents'), 0);
    if (current === offset) return;
    bar.setAttribute('data-sc-reward-offset-cents', String(offset));
    if (window.SC_refreshRewardBars) window.SC_refreshRewardBars();
  };

  Configurator.prototype.bindRewardBar = function () {
    var self = this;
    if (!this.rewardBarEl()) return;
    this.scRewardCart = null;
    this.onRewardCart = function (evt) {
      if (self.destroyed) return;
      var cart = evt && evt.detail && evt.detail.cart;
      if (cart && Array.isArray(cart.items)) self.scRewardCart = cart;
      self.syncRewardBar();
      try { self.decorateRewardPrediction(); } catch (error) {}
    };
    document.addEventListener('cart:updated', this.onRewardCart);
    if (window.SC_getSharedCart) {
      window.SC_getSharedCart().then(function (cart) {
        if (self.destroyed) return;
        if (cart && Array.isArray(cart.items)) {
          self.scRewardCart = cart;
          self.syncRewardBar();
          try { self.decorateRewardPrediction(); } catch (error) {}
        }
      }).catch(function () {});
    }
  };

  /* ---- Media nav thumbnails (desktop) ---- */

  /** 120px tiles must not load 1600px heroes: swap the Shopify CDN width
      param for a 240px (2x) rendition. Decoding eight full-size images -
      one an animated GIF - stalled the main thread and made the strip
      scroll feel steppy and blocked. */
  function scpcThumbRendition(url) {
    if (!url) return '';
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=240');
    return url + (url.indexOf('?') === -1 ? '?width=240' : '&width=240');
  }

  Configurator.prototype.enhanceMediaNav = function () {
    var destination = this.root.querySelector('[data-scpc-media-root]');
    var nav = this.root.querySelector('[data-scpc-media-nav]');
    if (!destination || !nav) return;
    if (!nav.__scpcThumbGuards) {
      nav.__scpcThumbGuards = true;
      var scpcSelf = this;
      /* Clicking a partially visible <button> focuses it, and the browser
         instantly scrolls the focused element into view BEFORE the smooth
         centring runs - the "two small steps" glitch. Blocking mousedown's
         default suppresses focus-on-click; keyboard focus is unaffected. */
      nav.addEventListener('mousedown', function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-scpc-media-index]')) event.preventDefault();
      });
      /* Remember which thumb was clicked: aria-current only flips when the
         slide transition ends (~300ms), and centring on the stale value
         made the strip glide to the OLD thumb first, then hop to the new
         one - the measured cause of the steppy movement. */
      nav.addEventListener('click', function (event) {
        var scpcThumbBtn = event.target && event.target.closest ? event.target.closest('[data-scpc-media-index]') : null;
        if (scpcThumbBtn) {
          scpcSelf._scpcThumbClickIndex = scpcThumbBtn.getAttribute('data-scpc-media-index');
          scpcSelf._scpcThumbClickAt = Date.now();
        }
      }, true);
    }
    var slides = list(destination.querySelectorAll('[data-scpc-media-slide]'));
    var buttons = list(nav.querySelectorAll('[data-scpc-media-index]'));
    if (!buttons.length) return;
    nav.classList.toggle('scpc__media-nav--thumbs', buttons.length >= 2);
    buttons.forEach(function (button, index) {
      var slide = slides[index];
      var source = slide ? slide.querySelector('img') : null;
      var src = scpcThumbRendition(source ? (source.getAttribute('src') || source.currentSrc || source.src || '') : '');
      var existing = button.querySelector('.scpc__media-thumb');
      if (!src) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      if (existing) {
        if (existing.getAttribute('src') !== src) existing.setAttribute('src', src);
        return;
      }
      var img = document.createElement('img');
      img.className = 'scpc__media-thumb';
      img.setAttribute('src', src);
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      button.appendChild(img);
    });
  };

  Configurator.prototype.scrollThumbIntoView = function () {
    var nav = this.root.querySelector('[data-scpc-media-nav]');
    if (!nav || !nav.classList.contains('scpc__media-nav--thumbs')) return;
    /* Prefer the JUST-CLICKED thumb (recorded in the nav click listener):
       aria-current lags the click by the ~300ms slide transition, and the
       engine re-invokes syncMediaNav at display rate during it, so trusting
       aria-current sent the strip to the OLD thumb first. Falls back to
       aria-current for keyboard and programmatic changes. */
    var active = null;
    if (this._scpcThumbClickIndex != null && Date.now() - (this._scpcThumbClickAt || 0) < 800) {
      active = nav.querySelector('[data-scpc-media-index="' + this._scpcThumbClickIndex + '"]');
    }
    if (!active) active = nav.querySelector('[data-scpc-media-index][aria-current="true"]');
    if (!active) return;
    var navRect = nav.getBoundingClientRect();
    var rect = active.getBoundingClientRect();
    /* Always centre (no fully-visible early return); clamp explicitly.
       Native smooth scrolling runs on the compositor thread and stays
       fluid regardless of main-thread load. */
    var max = Math.max(0, nav.scrollWidth - nav.clientWidth);
    var target = nav.scrollLeft + (rect.left - navRect.left) - ((navRect.width - rect.width) / 2);
    target = Math.min(max, Math.max(0, target));
    if (Math.abs(target - nav.scrollLeft) < 1) return;
    /* Dedupe: the engine's transition ticker calls this every ~8ms with an
       unchanged destination. One scrollTo per destination is enough - the
       browser is already gliding there. Time-bounded so it can never lock. */
    if (target === this._scpcThumbLastGoal && Date.now() - (this._scpcThumbLastGoalAt || 0) < 600) return;
    this._scpcThumbLastGoal = target;
    this._scpcThumbLastGoalAt = Date.now();
    if (nav.scrollTo) nav.scrollTo({ left: target, behavior: 'smooth' });
    else nav.scrollLeft = target;
  };

  var scpcBaseRenderMediaNav = Configurator.prototype.renderMediaNav;
  Configurator.prototype.renderMediaNav = function () {
    scpcBaseRenderMediaNav.apply(this, arguments);
    try { this.enhanceMediaNav(); } catch (error) {}
    /* Reset to the first thumbnail only when the strip belongs to a NEW
       media set. No centring here: the engine always calls syncMediaNav
       directly after renderMediaNav, and the syncMediaNav wrapper is the
       SINGLE scrollThumbIntoView caller. Two back-to-back smooth scrolls
       to the same target restarted the easing mid-flight - that was the
       stepped, caught-feeling movement. */
    try {
      var scpcThumbNav = this.root.querySelector('[data-scpc-media-nav]');
      var scpcStripKey = text(this.currentMediaKey);
      if (scpcThumbNav && this._scpcThumbStripKey !== scpcStripKey) {
        this._scpcThumbStripKey = scpcStripKey;
        scpcThumbNav.scrollLeft = 0;
      }
    } catch (error) {}
  };

  var scpcBaseSyncMediaNav = Configurator.prototype.syncMediaNav;
  Configurator.prototype.syncMediaNav = function () {
    scpcBaseSyncMediaNav.apply(this, arguments);
    try { this.scrollThumbIntoView(); } catch (error) {}
    try { this.updateWatermarks(); } catch (error) {}
  };

  /* ---- Compare-at price on the extras cards ---- */

  Configurator.prototype.decorateQuantityCompareAt = function () {
    var self = this;
    var byId = {};
    this.config.quantities.forEach(function (item) { byId[item.id] = item; });
    list(this.root.querySelectorAll('[data-scpc-quantity]')).forEach(function (card) {
      var item = byId[card.getAttribute('data-quantity-id')];
      var priceEl = card.querySelector('[data-scpc-quantity-price]');
      if (!item || !priceEl || !priceEl.parentNode) return;
      var existing = priceEl.querySelector('.scpc__quantity-compare') || priceEl.parentNode.querySelector('.scpc__quantity-compare');
      var compareAt = cents(item.compareAt);
      var price = cents(item.price);
      if (compareAt <= price) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      var value = self.formatMoney(compareAt);
      if (existing) {
        if (existing.parentNode !== priceEl) priceEl.appendChild(existing);
        if (existing.textContent !== value) existing.textContent = value;
        return;
      }
      var struck = document.createElement('s');
      struck.className = 'scpc__quantity-compare';
      struck.textContent = value;
      priceEl.appendChild(struck);
    });
  };

  /* ---- Bundle media: show the matched bundle, not the last option ---- */

  var SCPC_BUNDLE_MEDIA_PREFIX = 'bundle-';

  Configurator.prototype.bundleMediaKey = function () {
    var bundle = this.resolution && this.resolution.bundle;
    var key = bundle ? text(bundle.mediaKey) : '';
    if (!key) return '';
    var template = this.templateFor(key);
    if (!template || !template.content.querySelector('[data-scpc-media-slide]')) return '';
    return key;
  };

  Configurator.prototype.showBundleMedia = function () {
    var key = this.bundleMediaKey();
    if (!key || this.currentMediaKey === key) return false;
    this.setMedia(key);
    return true;
  };

  /**
   * Bundle photos take precedence: whenever the build resolves to a bundle,
   * show that bundle's media - including when the click that completed the
   * build carried its own mediaKey (e.g. Birdie Bar completing a Super
   * Bundle). Runs inside the render wrapper, so it corrects the media right
   * after the engine has applied the clicked option's key. When the build
   * stops matching a bundle, hand control back to the option media.
   */
  Configurator.prototype.refreshBundleMedia = function () {
    var current = text(this.currentMediaKey);
    var key = this.bundleMediaKey();
    if (key) {
      if (key !== current) this.setMedia(key);
      return;
    }
    if (current.indexOf(SCPC_BUNDLE_MEDIA_PREFIX) !== 0) return;
    this.currentMediaKey = '';
    this.selectInitialMedia();
    if (!this.currentMediaKey) {
      var fallback = this.templateFor('__default');
      if (fallback && fallback.content.querySelector('[data-scpc-media-slide]')) this.setMedia('__default');
    }
  };

  Configurator.prototype.bindBundleMedia = function () {
    var self = this;
    this.onBundleMedia3dClose = function (evt) {
      if (self.destroyed) return;
      if (!evt || !evt.target || !self.root.contains(evt.target)) return;
      self.showBundleMedia();
      try { self.updateWatermarks(); } catch (error) {}
    };
    document.addEventListener('sc-configurator:3d-close', this.onBundleMedia3dClose);
  };

  /* ---- Reward prediction: gift + discount rows in the breakdown ----
     Basis = cart merchandise subtotal + current build (identical to the
     reward bar). Thresholds come from the bar's own markers, already
     converted to presentment cents. The discount percent is parsed from
     the tier label ("3% Off" -> 3). The shown discount is that percent of
     the BUILD only; items already in the cart get theirs in the cart. */

  var SCPC_PREDICTION_CLASS = 'scpc__review-prediction';

  Configurator.prototype.rewardPrediction = function () {
    var rewards = this.root.querySelector('[data-scpc-rewards]');
    var bar = rewards ? rewards.querySelector('[data-sc-reward-bar]') : null;
    var resolution = this.resolution;
    if (!rewards || !bar || !resolution || !resolution.lines || !resolution.lines.length) return null;

    var buildTotal = cents(resolution.total);
    var cart = this.scRewardCart;
    var cartSubtotal = (cart && window.SC_merchandiseSubtotalCents) ? window.SC_merchandiseSubtotalCents(cart) : 0;
    var buildInCart = cart ? this.cartContainsBuild(cart) : false;
    var basis = buildInCart ? cartSubtotal : cartSubtotal + buildTotal;

    var giftInCart = false;
    if (cart && Array.isArray(cart.items)) {
      for (var i = 0; i < cart.items.length; i++) {
        var props = cart.items[i].properties || {};
        if (props._sc_threshold_gift === 'true') { giftInCart = true; break; }
      }
    }

    var gift = null;
    var giftMarker = bar.querySelector('.sc-reward-bar__marker[data-tier-type="gift"]');
    var giftPriceCents = integer(rewards.getAttribute('data-scpc-gift-price-cents'), 0);
    var giftCompareCents = integer(rewards.getAttribute('data-scpc-gift-compare-cents'), 0);
    var giftWas = Math.max(giftPriceCents, giftCompareCents);
    if (giftMarker && giftWas > 0 && !giftInCart) {
      var giftThreshold = integer(giftMarker.getAttribute('data-threshold-cents'), 0);
      if (!giftThreshold && window.SC_convertAudCents) {
        giftThreshold = window.SC_convertAudCents(giftMarker.getAttribute('data-aud-threshold-cents'), true);
      }
      if (giftThreshold > 0 && basis >= giftThreshold) {
        gift = {
          title: text(rewards.getAttribute('data-scpc-gift-title')) || 'Free gift',
          was: giftWas
        };
      }
    }

    var discount = null;
    var discountMarker = bar.querySelector('.sc-reward-bar__marker[data-tier-type="discount"]');
    if (discountMarker) {
      var discountLabel = text(discountMarker.getAttribute('data-tier-label')) || 'Discount';
      var pctMatch = discountLabel.match(/(\d+(?:\.\d+)?)\s*%/);
      var pct = pctMatch ? parseFloat(pctMatch[1]) : 0;
      var discountThreshold = integer(discountMarker.getAttribute('data-threshold-cents'), 0);
      if (!discountThreshold && window.SC_convertAudCents) {
        discountThreshold = window.SC_convertAudCents(discountMarker.getAttribute('data-aud-threshold-cents'), false);
      }
      if (pct > 0 && discountThreshold > 0 && basis >= discountThreshold) {
        /* Order-scoped: Shopify applies the % to the whole order (cart +
           build + protection), so estimate on the same basis the tiers
           unlock on. Build-only maths made the estimate miss checkout by
           the protection line's discounted value. */
        discount = {
          label: discountLabel,
          cents: Math.round(basis * pct / 100)
        };
      }
    }

    if (!gift && !discount) return null;

    var referenceBase = Math.max(cents(resolution.compareAtTotal), buildTotal);
    var reference = referenceBase + (gift ? gift.was : 0);
    return {
      gift: gift,
      discount: discount,
      reference: reference,
      total: buildTotal,
      /* Estimated order total at checkout: the discount basis minus the
         order discount - i.e. everything checkout will charge ex shipping.
         Without a discount it falls back to the build total (only the
         percent credit mode reads it then). */
      payable: (discount ? basis - discount.cents : buildTotal),
      savings: Math.max(0, reference - buildTotal)
    };
  };

  /**
   * Redeemly store-credit teaser. Display-only: store credit is future value,
   * not a discount on this order, so it never joins the savings or total
   * maths. Percent is a section setting - keep it matching the Redeemly
   * program. Basis is the estimated checkout total (after the predicted %
   * discount when unlocked, otherwise the build total).
   */
  Configurator.prototype.storeCreditTeaser = function (prediction) {
    var host = this.root.querySelector('[data-scpc-credit-mode]');
    var resolution = this.resolution;
    if (!host || !resolution || !resolution.lines || !resolution.lines.length) return '';

    /* Same basis as the reward tiers: cart merchandise subtotal + build. */
    var creditBuildTotal = cents(resolution.total);
    var creditCart = this.scRewardCart;
    var creditCartSubtotal = (creditCart && window.SC_merchandiseSubtotalCents) ? window.SC_merchandiseSubtotalCents(creditCart) : 0;
    var creditOrderBasis = (creditCart && this.cartContainsBuild(creditCart)) ? creditCartSubtotal : creditCartSubtotal + creditBuildTotal;

    /* Redeemly minimum: $90 AUD and up earns the credit (inclusive - the
       existing < comparison honours that). Convert AUD to presentment via
       the same helper every other threshold uses. Below it, no line - the
       widget's "Spend $X more" teaser must not read as an earned bonus. */
    var creditMinOrderAud = (parseFloat(host.getAttribute('data-scpc-credit-min-order')) || 0) * 100;
    var creditMinOrder = (creditMinOrderAud > 0 && window.SC_convertAudCents)
      ? window.SC_convertAudCents(creditMinOrderAud, false)
      : creditMinOrderAud;
    if (creditMinOrder > 0 && creditOrderBasis < creditMinOrder) return '';

    var mode = text(host.getAttribute('data-scpc-credit-mode')) || 'flat';
    var credit = 0;
    if (mode === 'percent') {
      var pct = parseFloat(host.getAttribute('data-scpc-credit-percent')) || 0;
      var basis = prediction ? prediction.payable : creditBuildTotal;
      if (pct <= 0 || basis <= 0) return '';
      credit = basis * pct / 100;
      var rounding = text(host.getAttribute('data-scpc-credit-rounding')) || 'whole';
      credit = rounding === 'exact' ? Math.round(credit) : Math.floor(credit / 100) * 100;
    } else {
      /* Flat rate. Source of truth is the Redeemly widget's own text
         ("... earn $5 in store credit") - parse the amount after "earn".
         The slider covers the moment before Redeemly's async init renders,
         or if the app is removed. */
      credit = (parseFloat(host.getAttribute('data-scpc-credit-amount')) || 0) * 100;
      var creditWidget = document.querySelector('.redeemly-cart-widget, .mcb-cart-widget');
      if (creditWidget) {
        var creditEarnMatch = (creditWidget.textContent || '').match(/earn[^$]*\$\s*([\d.,]+)/i);
        if (creditEarnMatch) {
          var creditParsed = Math.round(parseFloat(creditEarnMatch[1].replace(/,/g, '')) * 100);
          if (creditParsed > 0) credit = creditParsed;
        }
      }
    }
    if (credit <= 0) return '';
    var template = text(host.getAttribute('data-scpc-credit-template')) || 'Bonus: you’ll earn {amount} in store credit from this order.';
    var amount = this.formatMoney(credit).replace(/\.00(?=\D|$)/, '');
    return template.replace('{amount}', amount);
  };

  /** Idempotent: strips its own rows, re-adds per the current prediction,
      then rewrites the totals. Safe to run after any render or cart event. */
  Configurator.prototype.decorateRewardPrediction = function () {
    var self = this;
    var prediction = null;
    try { prediction = this.rewardPrediction(); } catch (error) { prediction = null; }

    list(this.root.querySelectorAll('.' + SCPC_PREDICTION_CLASS)).forEach(function (row) {
      if (row.parentNode) row.parentNode.removeChild(row);
    });

    list(this.root.querySelectorAll('[data-scpc-review-lines]')).forEach(function (container) {
      if (!prediction) return;
      var tag = container.tagName === 'UL' || container.tagName === 'OL' ? 'li' : 'div';

      if (prediction.gift) {
        var giftRow = document.createElement(tag);
        giftRow.className = 'scpc__review-line ' + SCPC_PREDICTION_CLASS;
        var giftLabel = document.createElement('span');
        giftLabel.textContent = prediction.gift.title;
        var giftTag = document.createElement('small');
        giftTag.className = 'scpc__review-source';
        giftTag.textContent = 'FREE gift';
        giftLabel.appendChild(giftTag);
        var giftPrice = document.createElement('span');
        var giftWas = document.createElement('s');
        giftWas.textContent = self.formatMoney(prediction.gift.was);
        var giftNow = document.createElement('strong');
        giftNow.textContent = self.formatMoney(0);
        giftPrice.appendChild(giftWas);
        giftPrice.appendChild(document.createTextNode(' '));
        giftPrice.appendChild(giftNow);
        giftRow.appendChild(giftLabel);
        giftRow.appendChild(giftPrice);
        var reference = container.querySelector('.scpc__review-reference');
        if (reference) container.insertBefore(giftRow, reference);
        else container.appendChild(giftRow);
      }

      if (prediction.discount) {
        /* Bridge the build total to the order basis so the column chains:
           Total + (protection / other cart items) − discount = estimate.
           Without this row the order-scoped figures below looked wrong
           whenever Package Protection was on. */
        var bridgeCents = prediction.payable + prediction.discount.cents - prediction.total;
        if (bridgeCents > 0) {
          var bridgeRow = document.createElement(tag);
          bridgeRow.className = 'scpc__review-after scpc__review-bridge ' + SCPC_PREDICTION_CLASS;
          var bridgeLabel = document.createElement('span');
          bridgeLabel.textContent = 'Also in your cart';
          var bridgePrice = document.createElement('strong');
          bridgePrice.textContent = '+' + self.formatMoney(bridgeCents);
          bridgeRow.appendChild(bridgeLabel);
          bridgeRow.appendChild(bridgePrice);
          container.appendChild(bridgeRow);
        }

        var discountRow = document.createElement(tag);
        discountRow.className = 'scpc__review-saving ' + SCPC_PREDICTION_CLASS;
        var discountLabel = document.createElement('span');
        discountLabel.textContent = prediction.discount.label + ' unlocked';
        var discountPrice = document.createElement('strong');
        discountPrice.textContent = '−' + self.formatMoney(prediction.discount.cents);
        discountRow.appendChild(discountLabel);
        discountRow.appendChild(discountPrice);
        container.appendChild(discountRow);

        var afterRow = document.createElement(tag);
        afterRow.className = 'scpc__review-after ' + SCPC_PREDICTION_CLASS;
        var afterLabel = document.createElement('span');
        afterLabel.textContent = 'Estimated total at checkout';
        var afterPrice = document.createElement('strong');
        afterPrice.textContent = self.formatMoney(prediction.payable);
        afterRow.appendChild(afterLabel);
        afterRow.appendChild(afterPrice);
        container.appendChild(afterRow);
      }
    });

    /* Bonus credit line: last row, shown for any resolved build. Shares the
       prediction class so the idempotent sweep above cleans it up too. */
    var creditTeaser = '';
    try { creditTeaser = this.storeCreditTeaser(prediction); } catch (error) { creditTeaser = ''; }
    if (creditTeaser) {
      list(this.root.querySelectorAll('[data-scpc-review-lines]')).forEach(function (container) {
        var creditTag = container.tagName === 'UL' || container.tagName === 'OL' ? 'li' : 'div';
        var creditRow = document.createElement(creditTag);
        creditRow.className = 'scpc__review-credit ' + SCPC_PREDICTION_CLASS;
        var creditText = document.createElement('span');
        creditText.textContent = creditTeaser;
        creditRow.appendChild(creditText);
        container.appendChild(creditRow);
      });
    }

    if (!prediction) return;

    /* Do NOT touch [data-scpc-total] or the review Total row: the build total
       stays pre-discount, which is exactly what the cart's line prices sum to
       after adding. The 3% is an order discount applied at checkout - it gets
       its own row plus the estimated-checkout row instead. (Overriding the
       header to the discounted figure made it disagree with the review row
       and the cart: $338.47 vs $348.94 - the bug this replaces.) */
    list(this.root.querySelectorAll('[data-scpc-compare-total]')).forEach(function (element) {
      element.textContent = self.formatMoney(prediction.reference);
      element.hidden = prediction.savings <= 0;
    });
    list(this.root.querySelectorAll('[data-scpc-savings]')).forEach(function (element) {
      element.textContent = self.config.strings.savings + ' ' + self.formatMoney(prediction.savings);
      element.hidden = prediction.savings <= 0;
    });
    list(this.root.querySelectorAll('.scpc__review-reference s')).forEach(function (element) {
      element.textContent = self.formatMoney(prediction.reference);
    });
    /* Regular price now includes the gift's was-price, so the savings row must
       too, or the column stops adding up (427.87 − 63.94 ≠ 348.94). */
    if (prediction.gift) {
      list(this.root.querySelectorAll('.scpc__review-saving:not(.' + SCPC_PREDICTION_CLASS + ') strong')).forEach(function (element) {
        element.textContent = '−' + self.formatMoney(prediction.savings);
      });
    }
  };

  var scpcBaseRenderReview = Configurator.prototype.renderReview;
  Configurator.prototype.renderReview = function () {
    scpcBaseRenderReview.apply(this, arguments);
    try { this.decorateRewardPrediction(); } catch (error) {}
  };

  /* ---- Photo watermarks: shown while their option is selected ----
     The layer is a viewer sibling (the engine wipes media-root's children
     on media swaps, and the viewer box extends over the thumbnails), so
     its height is synced to the media area's rendered height here. */
  Configurator.prototype.updateWatermarks = function () {
    var self = this;
    var layer = this._scpcWatermarkLayer || this.root.querySelector('[data-scpc-watermark-layer]');
    if (!layer) return;
    this._scpcWatermarkLayer = layer;
    layer.style.removeProperty('height');
    var mediaRoot = this.root.querySelector('[data-scpc-media-root]');
    /* The layer lives INSIDE media-root and fills it via CSS inset:0, so it
       tracks the image box natively - expand transition included. The old
       measured-height approach went stale when expand resized the media
       without a render, stranding the badge mid-image. The engine wipes
       media-root's children on media swaps, but innerHTML='' only detaches
       nodes - we hold the reference and re-append. */
    if (mediaRoot && layer.parentNode !== mediaRoot) mediaRoot.appendChild(layer);
    /* Locked to the first image of the reel: no badge over lifestyle or
       testimonial slides. A single-image set (no nav buttons) counts as
       the first image. */
    var mediaNav = this.root.querySelector('[data-scpc-media-nav]');
    var navButtons = mediaNav ? mediaNav.querySelectorAll('[data-scpc-media-index]') : null;
    var onFirstSlide = !navButtons || !navButtons.length ||
      !!mediaNav.querySelector('[data-scpc-media-index="0"][aria-current="true"]');
    var anyVisible = false;
    list(layer.querySelectorAll('[data-scpc-watermark]')).forEach(function (mark) {
      var key = mark.getAttribute('data-scpc-watermark-key');
      var value = mark.getAttribute('data-scpc-watermark-value');
      var on = !!(onFirstSlide && key && value && self.root.querySelector('[data-scpc-option][data-key="' + key + '"][data-val="' + value + '"][aria-checked="true"]'));
      mark.hidden = !on;
      if (on) anyVisible = true;
    });
    layer.hidden = !anyVisible;
  };

  /* ---- Lifecycle wrappers ---- */

  var scpcBaseRender = Configurator.prototype.render;
  Configurator.prototype.render = function () {
    scpcBaseRender.call(this);
    try { this.decorateQuantityCompareAt(); } catch (error) {}
    try { this.enhanceMediaNav(); } catch (error) {}
    try { this.syncRewardBar(); } catch (error) {}
    try { this.refreshBundleMedia(); } catch (error) {}
    try { this.decorateRewardPrediction(); } catch (error) {}
    try { this.updateWatermarks(); } catch (error) {}
  };

  /* Mobile dock sheet (v32): a tap on the scrim - the bar's ::before, so
     the event target is the bar itself - closes the open review sheet by
     driving the existing toggle. Everything else is CSS. */
  Configurator.prototype.bindDockSheet = function () {
    var bar = this.root.querySelector('[data-scpc-purchase-bar]');
    if (!bar || bar.__scpcDockBound) return;
    bar.__scpcDockBound = true;
    bar.addEventListener('click', function (event) {
      if (event.target !== bar) return;
      var toggle = bar.querySelector('[data-scpc-review-toggle][aria-expanded="true"]');
      if (toggle) toggle.click();
    });
  };

  var scpcBaseBind = Configurator.prototype.bind;
  Configurator.prototype.bind = function () {
    scpcBaseBind.call(this);
    this.bindRewardBar();
    this.bindBundleMedia();
    this.bindDockSheet();
  };

  var scpcBaseDestroy = Configurator.prototype.destroy;
  Configurator.prototype.destroy = function () {
    if (this.onRewardCart) {
      document.removeEventListener('cart:updated', this.onRewardCart);
      this.onRewardCart = null;
    }
    if (this.onBundleMedia3dClose) {
      document.removeEventListener('sc-configurator:3d-close', this.onBundleMedia3dClose);
      this.onBundleMedia3dClose = null;
    }
    scpcBaseDestroy.call(this);
  };

  /* v48 — step scrolling. Desktop: the page only moves when the opened
     step's header is out of view, and then aligns it under the sticky top
     (scroll-margin-top, set in CSS). Any page scroll drags the sticky media
     column, which is the shift Russ wants gone. Mobile keeps the old
     behaviour, where scrolling to the step is what makes the flow work. */
  function scpcScrollStep(element, block) {
    if (!element || !element.scrollIntoView) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var desktop = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
    if (desktop) {
      var head = element.querySelector('[data-scpc-step-toggle]') || element;
      var rect = head.getBoundingClientRect();
      var margin = parseFloat(window.getComputedStyle(element).scrollMarginTop) || 0;
      if (rect.top >= margin && rect.bottom <= window.innerHeight) return;
      block = 'start';
    }
    try { element.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: block }); }
    catch (error) { element.scrollIntoView(); }
  }

  /* v48 — "usually $X" beside the bundle delta on option cards. The option's
     own product price is what it costs on its own; the delta is what it adds
     to the bundle. Shown only when the delta is the better number. */
  Configurator.prototype.decorateOptionUsual = function () {
    var self = this;
    list(this.root.querySelectorAll('[data-scpc-option-price]')).forEach(function (priceEl) {
      var existing = priceEl.querySelector('.scpc__option-usual');
      var option = self.findOption(priceEl);
      if (!option) { if (existing) priceEl.removeChild(existing); return; }
      var retail = Math.max(cents(option.price), cents(option.compareAt));
      var selected = self.optionSelected(option, self.state.selections);
      var hypothetical = selected ? null : self.hypotheticalOption(option);
      var delta = hypothetical ? integer(hypothetical.delta, 0) : 0;
      // A swap (another priced option in this step is already selected) is
      // a difference between two products, not an add-on. No "usually" there.
      var swap = self.config.options.some(function (other) {
        return other !== option && other.stepKey === option.stepKey && cents(other.price) > 0 && self.optionSelected(other, self.state.selections);
      });
      var show = !selected && !swap && option.available && hypothetical && hypothetical.resolution.valid && delta > 0 && retail > delta;
      if (!show) { if (existing) priceEl.removeChild(existing); return; }
      var label = self.formatMoney(retail);
      if (existing && existing.getAttribute('data-scpc-usual') === label) return;
      if (existing) priceEl.removeChild(existing);
      var span = document.createElement('span');
      span.className = 'scpc__option-usual';
      span.setAttribute('data-scpc-usual', label);
      span.appendChild(document.createTextNode(' usually '));
      var struck = document.createElement('s');
      struck.textContent = label;
      span.appendChild(struck);
      priceEl.appendChild(span);
    });
  };

  var scpcBaseRenderOptionsV48 = Configurator.prototype.renderOptions;
  Configurator.prototype.renderOptions = function () {
    var result = scpcBaseRenderOptionsV48.apply(this, arguments);
    try { this.decorateOptionUsual(); } catch (error) { /* decoration only */ }
    return result;
  };

  /* ================================================================
     FOOD TABS (v65) — module v2. Supersedes v55–v63 in full.
     Collection-driven picker per range ("tab"). Food never touches the
     bundle signature: every added size becomes an addon line appended by
     the resolve wrapper, so review, totals, cart payload, reward prediction
     and cartContainsBuild follow with no other wiring.

     State per tab:
       this.state.foods[tabKey] = { productId, focus, lines: { variantId: qty } }
       this.state.foods['__skip:<stepKey>'] = true      ("No food this time")
     ================================================================ */
  var SCPC_FOOD_STORAGE_SUFFIX = ':foods';

  function scpcFoodClampQty(range, value) {
    var max = Math.max(1, integer(range && range.max, 3));
    return Math.max(1, Math.min(max, integer(value, 1)));
  }

  Configurator.prototype.foodState = function () {
    if (!this.state.foods || typeof this.state.foods !== 'object') this.state.foods = {};
    return this.state.foods;
  };

  /* Parse every <script data-scpc-food-range> once; index products and variants. */
  Configurator.prototype.foodRanges = function () {
    if (this._foodRanges) return this._foodRanges;
    var self = this;
    this._foodRanges = [];
    this._foodRangesByKey = {};
    list(this.root.querySelectorAll('script[data-scpc-food-range]')).forEach(function (script) {
      var range = null;
      try { range = JSON.parse(script.textContent || 'null'); } catch (error) { range = null; }
      if (!range || !range.key) return;
      range.stepKey = text(range.stepKey);
      range.max = Math.max(1, integer(range.max, 3));
      range.products = Array.isArray(range.products) ? range.products : [];
      range.productsById = {};
      range.variantsById = {};
      range.products.forEach(function (product) {
        product.variants = Array.isArray(product.variants) ? product.variants : [];
        range.productsById[text(product.id)] = product;
        product.variants.forEach(function (variant) {
          variant.productId = product.id;
          variant.single = !!product.single;
          range.variantsById[text(variant.id)] = variant;
        });
      });
      self._foodRanges.push(range);
      self._foodRangesByKey[range.key] = range;
    });
    return this._foodRanges;
  };

  Configurator.prototype.foodRange = function (key) {
    this.foodRanges();
    return this._foodRangesByKey[key] || null;
  };

  /* Normalised entry for a tab (always the v2 shape; never null). */
  Configurator.prototype.foodEntry = function (key) {
    var foods = this.foodState();
    var entry = foods[key];
    if (!entry || typeof entry !== 'object') entry = { productId: null, focus: null, lines: {} };
    if (!entry.lines || typeof entry.lines !== 'object') entry.lines = {};
    if (entry.productId === undefined) entry.productId = null;
    if (entry.focus === undefined) entry.focus = null;
    return entry;
  };

  Configurator.prototype.foodEntryIsEmpty = function (entry) {
    return !entry.productId && !entry.focus && !Object.keys(entry.lines).length;
  };

  /* Every line in a tab as { variant, product, quantity }, in insertion order.
     Unknown variants are dropped; unavailable ones are kept so pricing can report them. */
  Configurator.prototype.foodLinesFor = function (key) {
    var range = this.foodRange(key);
    var entry = this.foodEntry(key);
    if (!range) return [];
    var self = this;
    return Object.keys(entry.lines).map(function (variantId) {
      var variant = range.variantsById[variantId];
      var product = variant ? range.productsById[text(variant.productId)] : null;
      var qty = integer(entry.lines[variantId], 0);
      if (!variant || !product || qty <= 0) return null;
      return { variant: variant, product: product, quantity: scpcFoodClampQty(range, qty) };
    }).filter(Boolean);
  };

  /* What the panel is showing: the viewed product and the focused size (may be null). */
  Configurator.prototype.foodView = function (key) {
    var range = this.foodRange(key);
    var entry = this.foodEntry(key);
    if (!range) return { range: null, entry: entry, product: null, variant: null, quantity: 0 };
    var product = entry.productId ? (range.productsById[text(entry.productId)] || null) : null;
    var variant = entry.focus ? (range.variantsById[text(entry.focus)] || null) : null;
    if (variant && product && text(variant.productId) !== text(product.id)) variant = null;
    var quantity = variant ? integer(entry.lines[text(variant.id)], 0) : 0;
    return { range: range, entry: entry, product: product, variant: variant, quantity: quantity };
  };

  Configurator.prototype.foodLineCount = function (key) { return this.foodLinesFor(key).length; };

  Configurator.prototype.foodProductLineCount = function (key, productId) {
    return this.foodLinesFor(key).filter(function (line) { return text(line.product.id) === text(productId); }).length;
  };

  /* ---- persistence: separate key beside the engine's own ---- */
  var scpcFoodBasePersist = Configurator.prototype.persist;
  Configurator.prototype.persist = function () {
    scpcFoodBasePersist.apply(this, arguments);
    if (!this.config || !this.config.persist || !window.sessionStorage) return;
    try { sessionStorage.setItem(this.storageKey() + SCPC_FOOD_STORAGE_SUFFIX, JSON.stringify(this.foodState())); }
    catch (error) { /* storage unavailable */ }
  };

  var scpcFoodBaseRestore = Configurator.prototype.restore;
  Configurator.prototype.restore = function () {
    scpcFoodBaseRestore.apply(this, arguments);
    if (!this.state) return;
    this.state.foods = {};
    if (!this.config || !this.config.persist || !window.sessionStorage) return;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(this.storageKey() + SCPC_FOOD_STORAGE_SUFFIX) || 'null'); }
    catch (error) { saved = null; }
    if (!saved || typeof saved !== 'object') return;
    var self = this;
    Object.keys(saved).forEach(function (savedKey) {
      if (savedKey.indexOf('__skip:') === 0 && saved[savedKey]) self.state.foods[savedKey] = true;
    });
    this.foodRanges().forEach(function (range) {
      var raw = saved[range.key];
      if (!raw || typeof raw !== 'object') return;
      var entry = { productId: null, focus: null, lines: {} };
      // v2 shape
      if (raw.lines && typeof raw.lines === 'object') {
        Object.keys(raw.lines).forEach(function (variantId) {
          var variant = range.variantsById[variantId];
          if (!variant || !variant.available) return;
          var product = range.productsById[text(variant.productId)];
          if (!product || !product.available) return;
          entry.lines[variantId] = scpcFoodClampQty(range, raw.lines[variantId]);
        });
      } else if (raw.variantId && raw.productId) {
        // v1 shape (pre-v65 sessions): one variant + quantity
        var v1 = range.variantsById[text(raw.variantId)];
        if (v1 && v1.available) entry.lines[text(v1.id)] = scpcFoodClampQty(range, raw.quantity);
      }
      var viewed = raw.productId ? range.productsById[text(raw.productId)] : null;
      if (viewed && viewed.available) entry.productId = viewed.id;
      var focus = raw.focus ? range.variantsById[text(raw.focus)] : null;
      if (focus && entry.productId && text(focus.productId) === text(entry.productId)) entry.focus = focus.id;
      if (!self.foodEntryIsEmpty(entry)) self.state.foods[range.key] = entry;
    });
  };

  /* ---- pricing: append every line as an addon; commit atomically ---- */
  var scpcFoodBaseResolve = Configurator.prototype.resolve;
  Configurator.prototype.resolve = function (selections, quantities) {
    var solution = scpcFoodBaseResolve.call(this, selections, quantities);
    try {
      this.applyFoodLines(solution);
    } catch (error) {
      solution.valid = false;
      solution.reason = 'Food items could not be priced. Remove them and try again.';
      solution.foodError = true;
      if (window.console && console.error) console.error('[scpc food] pricing failed', error);
    }
    return solution;
  };

  Configurator.prototype.applyFoodLines = function (solution) {
    if (!solution || !Array.isArray(solution.lines)) return;
    var self = this;
    var pending = [];
    var added = 0;
    var reference = 0;
    var soldOut = '';
    var hiddenSteps = (solution.effects && solution.effects.hiddenSteps) || {};
    var disabledSteps = (solution.effects && solution.effects.disabledSteps) || {};
    this.foodRanges().forEach(function (range) {
      if (hiddenSteps[range.stepKey] || disabledSteps[range.stepKey]) return;
      self.foodLinesFor(range.key).forEach(function (line) {
        if (!line.variant.available || !validVariant(line.variant.id)) {
          if (!soldOut) soldOut = line.product.title + ' is sold out. Choose another size or remove it.';
          return;
        }
        var price = cents(line.variant.price);
        var compareAt = cents(line.variant.compareAt);
        pending.push({
          id: line.variant.id,
          quantity: line.quantity,
          price: price,
          compareAt: compareAt,
          label: line.product.title + (line.variant.single ? '' : ' · ' + line.variant.title),
          source: 'addon',
          food: range.key,
          order: 0
        });
        added += price * line.quantity;
        reference += Math.max(price, compareAt) * line.quantity;
      });
    });
    pending.forEach(function (line) { line.order = solution.lines.length; solution.lines.push(line); });
    solution.foodTotal = added;
    if (soldOut) { solution.valid = false; solution.reason = solution.reason || soldOut; }
    if (!added) return;
    solution.total = integer(solution.total, 0) + added;
    solution.referenceTotal = integer(solution.referenceTotal, 0) + reference;
    solution.compareAtTotal = Math.max(solution.total, solution.referenceTotal);
    solution.savings = Math.max(0, solution.compareAtTotal - solution.total);
  };

  /* ---- cart payload: tag food lines by position ---- */
  var scpcFoodBaseCartItems = Configurator.prototype.cartItems;
  Configurator.prototype.cartItems = function () {
    var self = this;
    var items = scpcFoodBaseCartItems.apply(this, arguments);
    var lines = (this.resolution && this.resolution.lines) || [];
    if (items.length !== lines.length) return items;
    return items.map(function (item, index) {
      var line = lines[index];
      if (!line || !line.food || text(line.id) !== text(item.id)) return item;
      var range = self.foodRange(line.food);
      item.properties = item.properties || {};
      item.properties._sc_food = range ? range.label : line.food;
      return item;
    });
  };

  /* ---- change event, step summary, completion ---- */
  var scpcFoodBaseDetail = Configurator.prototype.detail;
  Configurator.prototype.detail = function () {
    var detail = scpcFoodBaseDetail.apply(this, arguments);
    detail.foods = copyObject(this.foodState());
    return detail;
  };

  Configurator.prototype.foodSkipKey = function (stepKey) { return '__skip:' + text(stepKey); };
  Configurator.prototype.foodSkipped = function (stepKey) { return !!this.foodState()[this.foodSkipKey(stepKey)]; };

  Configurator.prototype.foodLabelsForStep = function (stepKey) {
    var self = this;
    if (this.foodSkipped(stepKey)) {
      var skipButton = this.root.querySelector('[data-scpc-food-skip="' + stepKey + '"] > span');
      return [skipButton ? text(skipButton.textContent).trim() : 'No food this time'];
    }
    // Header summary is a count; the chips under the panel carry the detail and the remove controls.
    var count = 0;
    this.foodRanges().forEach(function (range) {
      if (range.stepKey === stepKey) count += self.foodLineCount(range.key);
    });
    if (!count) return [];
    var wrap = this.root.querySelector('[data-scpc-food="' + stepKey + '"]');
    var one = (wrap && wrap.getAttribute('data-summary-one')) || '1 item added';
    var many = (wrap && wrap.getAttribute('data-summary-many')) || '{count} items added';
    return [count === 1 ? one : many.replace('{count}', String(count))];
  };

  var scpcFoodBaseSummary = Configurator.prototype.summaryForStep;
  Configurator.prototype.summaryForStep = function (step) {
    var base = scpcFoodBaseSummary.apply(this, arguments);
    var labels = this.foodLabelsForStep(step.key);
    if (!labels.length) return base;
    if (base && base !== step.subheading) return base + ', ' + labels.join(', ');
    return labels.join(', ');
  };

  Configurator.prototype.foodStepHasValue = function (stepKey) {
    var self = this;
    if (this.foodSkipped(stepKey)) return true;
    return this.foodRanges().some(function (range) { return range.stepKey === stepKey && self.foodLineCount(range.key) > 0; });
  };

  var scpcFoodBaseStepHasValue = Configurator.prototype.stepHasValue;
  Configurator.prototype.stepHasValue = function (step, selections, quantities, effects) {
    var base = scpcFoodBaseStepHasValue.apply(this, arguments);
    if (base) return true;
    if (!step || !this.foodRanges().length) return base;
    return this.foodStepHasValue(step.key);
  };

  /* ---- size change resets food, like every other step ---- */
  var scpcFoodBaseUpdate = Configurator.prototype.update;
  Configurator.prototype.update = function (changedKey) {
    var current = '';
    try { current = text(this.connectedValue()); } catch (error) { current = ''; }
    if (this._foodSizeValue !== undefined && current !== this._foodSizeValue) {
      var foods = this.foodState();
      var had = Object.keys(foods).length > 0;
      Object.keys(foods).forEach(function (key) { delete foods[key]; });
      this._foodActiveTab = '';
      if (had) { try { dispatch(this.root, 'sc-configurator:food', { event: 'sc_food_change', action: 'reset', food_range: '', reason: 'size-change' }); } catch (error) {} }
    }
    this._foodSizeValue = current;
    return scpcFoodBaseUpdate.apply(this, arguments);
  };

  /* ---- state changes (single commit path) ---- */
  Configurator.prototype.commitFood = function (key, mutate, action, extra) {
    var range = this.foodRange(key);
    if (!range) return;
    var foods = this.foodState();
    var entry = this.foodEntry(key);
    mutate(entry, range);
    // Drop empty lines, clamp the rest.
    Object.keys(entry.lines).forEach(function (variantId) {
      var qty = integer(entry.lines[variantId], 0);
      if (qty <= 0 || !range.variantsById[variantId]) delete entry.lines[variantId];
      else entry.lines[variantId] = scpcFoodClampQty(range, qty);
    });
    if (entry.focus && !range.variantsById[text(entry.focus)]) entry.focus = null;
    if (this.foodEntryIsEmpty(entry)) delete foods[key]; else foods[key] = entry;
    if (Object.keys(entry.lines).length) delete foods[this.foodSkipKey(range.stepKey)];
    this._foodActiveTab = key;
    this.update('food:' + key);
    this.trackFood(key, action, extra);
  };

  /* Dropdown / strip / listbox all land here. */
  Configurator.prototype.chooseFoodProduct = function (key, productId, action) {
    var range = this.foodRange(key);
    if (!range) return;
    var product = productId ? range.productsById[text(productId)] : null;
    if (productId && (!product || !product.available)) return;
    var current = this.foodView(key);
    if (product && current.product && text(current.product.id) === text(product.id)) return;
    this.commitFood(key, function (entry) {
      entry.productId = product ? product.id : null;
      entry.focus = null;
      if (!product) return;
      // Focus an existing line of this product, else add the single variant at ×1.
      var existing = product.variants.filter(function (v) { return integer(entry.lines[text(v.id)], 0) > 0; })[0];
      if (existing) { entry.focus = existing.id; return; }
      if (product.single) {
        var only = product.variants.filter(function (v) { return v.available; })[0];
        if (only) { entry.lines[text(only.id)] = 1; entry.focus = only.id; }
      }
    }, action || 'product', { product_id: product ? product.id : null });
  };

  Configurator.prototype.chooseFoodVariant = function (key, variantId) {
    var range = this.foodRange(key);
    var variant = range && range.variantsById[text(variantId)];
    if (!variant || !variant.available) return;
    this.commitFood(key, function (entry) {
      entry.productId = variant.productId;
      entry.focus = variant.id;
      if (integer(entry.lines[text(variant.id)], 0) <= 0) entry.lines[text(variant.id)] = 1;
    }, 'size', { variant_id: variant.id });
  };

  Configurator.prototype.changeFoodQty = function (key, delta) {
    var view = this.foodView(key);
    if (!view.variant) return;
    var id = text(view.variant.id);
    var next = integer(view.entry.lines[id], 0) + delta;
    var single = !!view.variant.single;
    this.commitFood(key, function (entry) {
      if (next <= 0) {
        delete entry.lines[id];
        // A single-variant product has nothing left to pick: return the tab to its placeholder.
        if (single) { entry.productId = null; entry.focus = null; }
      } else {
        entry.lines[id] = next;
      }
    }, next <= 0 ? 'remove' : (delta > 0 ? 'increase' : 'decrease'), { variant_id: view.variant.id, quantity: Math.max(0, next) });
  };

  Configurator.prototype.removeFoodLine = function (key, variantId) {
    var id = text(variantId);
    var range = this.foodRange(key);
    var removed = range ? range.variantsById[id] : null;
    this.commitFood(key, function (entry) {
      delete entry.lines[id];
      if (text(entry.focus) === id) entry.focus = null;
      if (removed && removed.single && text(entry.productId) === text(removed.productId)) { entry.productId = null; entry.focus = null; }
    }, 'remove', { variant_id: variantId, quantity: 0 });
  };

  /* ---- skip choice ("No food this time") ---- */
  Configurator.prototype.setFoodSkip = function (stepKey, on) {
    var foods = this.foodState();
    var key = this.foodSkipKey(stepKey);
    if (on) {
      var self = this;
      this.foodRanges().forEach(function (range) { if (range.stepKey === stepKey) delete foods[range.key]; });
      foods[key] = true;
    } else {
      delete foods[key];
    }
    this.update('food-skip:' + stepKey);
    try { dispatch(this.root, 'sc-configurator:food', { event: 'sc_food_change', action: on ? 'skip' : 'unskip', food_range: '', step: stepKey }); } catch (error) {}
    if (on && typeof this.advanceFrom === 'function') this.advanceFrom(stepKey);
  };

  Configurator.prototype.trackFood = function (key, action, extra) {
    var view = this.foodView(key);
    var payload = {
      event: 'sc_food_change',
      action: action || 'change',
      food_range: key,
      product_id: view.product ? view.product.id : null,
      product_handle: view.product ? view.product.handle : '',
      variant_id: view.variant ? view.variant.id : null,
      quantity: view.quantity,
      lines_in_tab: this.foodLineCount(key),
      builder_key: this.config && this.config.builderKey ? this.config.builderKey : ''
    };
    if (extra) Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (error) {}
    try { dispatch(this.root, 'sc-configurator:food', payload); } catch (error) {}
  };

  /* ---- product info modal (reuses the section modal; no price, no select) ---- */
  Configurator.prototype.openFoodModal = function (key, trigger) {
    var view = this.foodView(key);
    var elements = this.modalElements();
    if (!view.product || !elements.modal) return;
    var product = view.product;
    this.modalItem = { food: key, id: 'food:' + key, label: product.shortTitle };
    this.modalFocus = trigger || document.activeElement;
    if (elements.title) elements.title.textContent = product.shortTitle;
    if (elements.body) {
      clear(elements.body);
      if (product.descriptionHtml) {
        /* Trusted store content rendered by Liquid (product.description), same trust level as tooltipHtml. */
        var rich = document.createElement('div');
        rich.className = 'scpc__food-modal-description';
        rich.innerHTML = product.descriptionHtml;
        elements.body.appendChild(rich);
      } else if (product.description) {
        var p = document.createElement('p'); p.textContent = product.description; elements.body.appendChild(p);
      }
      if (product.url) {
        var link = document.createElement('a');
        link.className = 'scpc__food-modal-link';
        link.href = product.url; link.target = '_blank'; link.rel = 'noopener';
        var skipButton = this.root.querySelector('[data-scpc-food-skip]');
        link.textContent = (skipButton && skipButton.getAttribute('data-view-label')) || 'View product page';
        elements.body.appendChild(link);
      }
      elements.body.hidden = !product.description && !product.url;
    }
    if (elements.media) {
      clear(elements.media);
      var src = (view.variant && view.variant.image) || product.image;
      if (src) { var img = document.createElement('img'); img.src = src; img.alt = ''; img.loading = 'lazy'; elements.media.appendChild(img); }
      elements.media.hidden = !src;
    }
    if (elements.mediaNav) elements.mediaNav.hidden = true;
    if (elements.mediaPrev) elements.mediaPrev.hidden = true;
    if (elements.mediaNext) elements.mediaNext.hidden = true;
    if (elements.price) elements.price.hidden = true;
    if (elements.select) elements.select.hidden = true;
    elements.modal.hidden = false;
    elements.modal.setAttribute('aria-hidden', 'false');
    elements.modal.classList.add('is-open');
    this.modalOpen = true;
    lockBody();
    var closeButton = elements.modal.querySelector('[data-scpc-modal-close]:not([data-scpc-modal-backdrop])');
    if (closeButton) { try { closeButton.focus({ preventScroll: true }); } catch (error) { closeButton.focus(); } }
  };

  var scpcFoodBaseCloseModal = Configurator.prototype.closeModal;
  Configurator.prototype.closeModal = function () {
    var wasFood = !!(this.modalItem && this.modalItem.food);
    var result = scpcFoodBaseCloseModal.apply(this, arguments);
    if (wasFood) {
      var elements = this.modalElements();
      if (elements.price) elements.price.hidden = false;
      if (elements.select) elements.select.hidden = false;
      if (elements.mediaNav) elements.mediaNav.hidden = false;
      if (elements.mediaPrev) elements.mediaPrev.hidden = false;
      if (elements.mediaNext) elements.mediaNext.hidden = false;
    }
    return result;
  };

  /* ---- custom picker: combobox trigger + listbox ---- */
  Configurator.prototype.foodPickerFor = function (key) {
    return this.root.querySelector('[data-scpc-food-picker="' + key + '"]');
  };

  Configurator.prototype.initFoodPickers = function () {
    list(this.root.querySelectorAll('[data-scpc-food-picker]')).forEach(function (picker) {
      if (picker.getAttribute('data-scpc-food-picker-ready') === 'true') return;
      var wrap = picker.parentNode && picker.parentNode.querySelector('.scpc__food-select-wrap');
      var select = wrap && wrap.querySelector('[data-scpc-food-product]');
      if (select) { wrap.classList.add('scpc__food-select-wrap--enhanced'); select.setAttribute('tabindex', '-1'); select.setAttribute('aria-hidden', 'true'); }
      picker.hidden = false;
      picker.setAttribute('data-scpc-food-picker-ready', 'true');
    });
  };

  Configurator.prototype.openFoodPicker = function (key) {
    var picker = this.foodPickerFor(key);
    if (!picker) return;
    var listEl = picker.querySelector('[data-scpc-food-list]');
    var trigger = picker.querySelector('[data-scpc-food-picker-trigger]');
    if (!listEl || !trigger) return;
    this.closeFoodPickers(key);
    listEl.hidden = false;
    picker.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    var current = listEl.querySelector('[role="option"][aria-selected="true"]') || listEl.querySelector('[role="option"]:not([aria-disabled="true"])');
    this.highlightFoodOption(key, current);
    try { listEl.focus({ preventScroll: true }); } catch (error) { listEl.focus(); }
  };

  Configurator.prototype.closeFoodPickers = function (exceptKey, returnFocus) {
    list(this.root.querySelectorAll('[data-scpc-food-picker].is-open')).forEach(function (picker) {
      var key = picker.getAttribute('data-scpc-food-picker');
      if (exceptKey && key === exceptKey) return;
      var listEl = picker.querySelector('[data-scpc-food-list]');
      var trigger = picker.querySelector('[data-scpc-food-picker-trigger]');
      if (listEl) listEl.hidden = true;
      picker.classList.remove('is-open');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) { try { trigger.focus({ preventScroll: true }); } catch (error) { trigger.focus(); } }
      }
    });
  };

  Configurator.prototype.highlightFoodOption = function (key, option) {
    var picker = this.foodPickerFor(key);
    if (!picker) return;
    var listEl = picker.querySelector('[data-scpc-food-list]');
    list(listEl.querySelectorAll('[role="option"]')).forEach(function (row) { row.classList.toggle('is-active', row === option); });
    if (option && option.id) listEl.setAttribute('aria-activedescendant', option.id);
    else listEl.removeAttribute('aria-activedescendant');
    if (option) { try { option.scrollIntoView({ block: 'nearest' }); } catch (error) {} }
  };

  Configurator.prototype.moveFoodHighlight = function (key, delta) {
    var picker = this.foodPickerFor(key);
    if (!picker) return;
    var rows = list(picker.querySelectorAll('[role="option"]:not([aria-disabled="true"])'));
    if (!rows.length) return;
    var active = picker.querySelector('[role="option"].is-active');
    var index = rows.indexOf(active);
    var next = index < 0 ? (delta > 0 ? 0 : rows.length - 1) : Math.max(0, Math.min(rows.length - 1, index + delta));
    this.highlightFoodOption(key, rows[next]);
  };

  /* ---- DOM sync (idempotent; runs after every render) ---- */
  Configurator.prototype.renderFood = function () {
    var self = this;
    if (!this.foodRanges().length) return;
    this.initFoodPickers();

    list(this.root.querySelectorAll('[data-scpc-food]')).forEach(function (wrap) {
      var stepKey = wrap.getAttribute('data-scpc-food');
      var tabs = list(wrap.querySelectorAll('[data-scpc-food-tab]'));
      var panels = list(wrap.querySelectorAll('[data-scpc-food-panel]'));
      if (!panels.length) return;
      var keys = panels.map(function (panel) { return panel.getAttribute('data-scpc-food-panel'); });

      var active = self._foodActiveTab && keys.indexOf(self._foodActiveTab) >= 0 ? self._foodActiveTab : '';
      if (!active) { for (var i = 0; i < keys.length; i++) { if (self.foodLineCount(keys[i])) { active = keys[i]; break; } } }
      if (!active) active = keys[0];
      self._foodActiveTab = active;

      tabs.forEach(function (tab) {
        var key = tab.getAttribute('data-scpc-food-tab');
        var on = key === active;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        tab.classList.toggle('is-active', on);
        var pip = tab.querySelector('[data-scpc-food-pip]');
        if (pip) { var count = self.foodLineCount(key); pip.textContent = String(count); pip.hidden = !count; }
      });

      panels.forEach(function (panel) {
        var key = panel.getAttribute('data-scpc-food-panel');
        panel.hidden = key !== active;
        self.renderFoodPanel(panel, key);
      });

      // Chips: one per line, across every tab in this step.
      var added = wrap.querySelector('[data-scpc-food-added]');
      var chips = wrap.querySelector('[data-scpc-food-chips]');
      if (added && chips) {
        var removeLabel = chips.getAttribute('data-remove-label') || 'Remove';
        var any = false;
        clear(chips);
        keys.forEach(function (key) {
          self.foodLinesFor(key).forEach(function (line) {
            any = true;
            var chip = document.createElement('span');
            chip.className = 'scpc__food-chip';
            var label = document.createElement('span');
            label.textContent = line.product.shortTitle + (line.variant.single ? '' : ' · ' + line.variant.title) + ' × ' + line.quantity;
            chip.appendChild(label);
            var remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'scpc__food-chip-remove';
            remove.setAttribute('data-scpc-food-remove', key);
            remove.setAttribute('data-scpc-food-remove-variant', text(line.variant.id));
            remove.setAttribute('aria-label', removeLabel + ' ' + line.product.shortTitle + (line.variant.single ? '' : ' ' + line.variant.title));
            remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
            chip.appendChild(remove);
            chips.appendChild(chip);
          });
        });
        added.hidden = !any;
      }

      // Skip button state.
      list(wrap.querySelectorAll('[data-scpc-food-skip]')).forEach(function (button) {
        var on = self.foodSkipped(button.getAttribute('data-scpc-food-skip') || stepKey);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.classList.toggle('is-selected', on);
      });
    });
  };

  Configurator.prototype.renderFoodPanel = function (panel, key) {
    var self = this;
    var range = this.foodRange(key);
    if (!range) return;
    var view = this.foodView(key);
    var product = view.product;
    var variant = view.variant;
    var entry = view.entry;

    var select = panel.querySelector('[data-scpc-food-product]');
    if (select) { var want = product ? text(product.id) : ''; if (select.value !== want) select.value = want; }

    this.renderFoodPicker(panel, key, product);
    this.renderFoodStrip(panel, key, product);

    var image = panel.querySelector('[data-scpc-food-image]');
    var empty = panel.querySelector('[data-scpc-food-image-empty]');
    var src = (variant && variant.image) || (product && product.image) || '';
    if (image) { if (src) { if (image.getAttribute('src') !== src) image.setAttribute('src', src); image.hidden = false; } else image.hidden = true; }
    if (empty) empty.hidden = !!src;

    var info = panel.querySelector('[data-scpc-food-info]');
    if (info) info.hidden = !product;

    var hint = panel.querySelector('[data-scpc-food-hint]');
    var sizes = panel.querySelector('[data-scpc-food-sizes]');
    var row = panel.querySelector('[data-scpc-food-row]');
    var qtyOut = panel.querySelector('[data-scpc-food-qty]');
    var priceEl = panel.querySelector('[data-scpc-food-price]');

    if (!product) {
      if (hint) hint.hidden = false;
      if (sizes) { sizes.hidden = true; clear(sizes); sizes.removeAttribute('data-scpc-food-stamp'); }
      if (row) row.hidden = true;
      return;
    }
    if (hint) hint.hidden = true;

    // Size pills: rebuilt when the product, the focus or any of its quantities change.
    if (sizes) {
      if (product.single) {
        sizes.hidden = true; clear(sizes); sizes.removeAttribute('data-scpc-food-stamp');
      } else {
        var stamp = text(product.id) + ':' + (variant ? text(variant.id) : '') + ':' + product.variants.map(function (v) { return integer(entry.lines[text(v.id)], 0); }).join(',');
        if (sizes.getAttribute('data-scpc-food-stamp') !== stamp) {
          clear(sizes);
          product.variants.forEach(function (candidate) {
            var qty = integer(entry.lines[text(candidate.id)], 0);
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'scpc__food-size';
            pill.setAttribute('data-scpc-food-variant', text(candidate.id));
            pill.setAttribute('data-scpc-food-key', key);
            var focused = !!variant && text(variant.id) === text(candidate.id);
            pill.setAttribute('aria-pressed', focused ? 'true' : 'false');
            pill.classList.toggle('is-selected', focused);
            pill.classList.toggle('has-qty', qty > 0);
            if (!candidate.available) { pill.disabled = true; pill.classList.add('is-sold-out'); }
            var name = document.createElement('span'); name.className = 'scpc__food-size-name'; name.textContent = candidate.title;
            var price = document.createElement('span'); price.className = 'scpc__food-size-price'; price.textContent = self.formatMoney(cents(candidate.price));
            pill.appendChild(name); pill.appendChild(price);
            if (qty > 0) { var count = document.createElement('span'); count.className = 'scpc__food-size-count'; count.textContent = '×' + qty; pill.appendChild(count); }
            sizes.appendChild(pill);
          });
          sizes.setAttribute('data-scpc-food-stamp', stamp);
        }
        sizes.hidden = false;
      }
    }

    // Stepper + price for the focused size (only when it is in the build).
    if (!variant || view.quantity <= 0) { if (row) row.hidden = true; return; }
    if (row) row.hidden = false;
    if (qtyOut) qtyOut.textContent = String(view.quantity);
    var plus = panel.querySelector('[data-scpc-food-plus]');
    if (plus) plus.disabled = view.quantity >= range.max;
    if (priceEl) {
      var line = cents(variant.price) * view.quantity;
      var retail = Math.max(cents(variant.price), cents(variant.compareAt)) * view.quantity;
      clear(priceEl);
      priceEl.appendChild(document.createTextNode('+' + self.formatMoney(line)));
      if (retail > line) {
        var usual = document.createElement('span');
        usual.className = 'scpc__option-usual';
        usual.appendChild(document.createTextNode(' usually '));
        var struck = document.createElement('s'); struck.textContent = self.formatMoney(retail);
        usual.appendChild(struck);
        priceEl.appendChild(usual);
      }
    }
  };

  Configurator.prototype.renderFoodPicker = function (panel, key, product) {
    var self = this;
    var picker = panel.querySelector('[data-scpc-food-picker]');
    if (!picker) return;
    var trigger = picker.querySelector('[data-scpc-food-picker-trigger]');
    var label = picker.querySelector('[data-scpc-food-picker-label]');
    var thumb = picker.querySelector('[data-scpc-food-picker-thumb]');
    var chosen = product ? text(product.id) : '';
    if (label) label.textContent = product ? product.shortTitle : (trigger.getAttribute('data-placeholder') || '');
    if (thumb) {
      var img = thumb.querySelector('img');
      var src = product && product.image ? product.image : '';
      if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      thumb.hidden = !src;
    }
    if (trigger) trigger.classList.toggle('has-value', !!product);
    list(picker.querySelectorAll('[role="option"]')).forEach(function (row) {
      var pid = row.getAttribute('data-scpc-food-list-product');
      var lines = self.foodProductLineCount(key, pid);
      row.setAttribute('aria-selected', chosen && pid === chosen ? 'true' : 'false');
      row.classList.toggle('has-items', lines > 0);
      var count = row.querySelector('[data-scpc-food-list-count]');
      if (count) { count.textContent = String(lines); count.hidden = lines <= 0; }
    });
  };

  Configurator.prototype.renderFoodStrip = function (panel, key, product) {
    var self = this;
    var strip = panel.querySelector('[data-scpc-food-strip]');
    if (!strip) return;
    var chosen = product ? text(product.id) : '';
    var target = null;
    list(strip.querySelectorAll('[data-scpc-food-strip-product]')).forEach(function (item) {
      var pid = item.getAttribute('data-scpc-food-strip-product');
      var on = chosen && pid === chosen;
      item.setAttribute('aria-selected', on ? 'true' : 'false');
      item.classList.toggle('is-selected', !!on);
      item.classList.toggle('has-items', self.foodProductLineCount(key, pid) > 0);
      if (on) target = item;
    });
    if (target && strip.getAttribute('data-scpc-food-strip-centred') !== chosen) {
      var left = target.offsetLeft - (strip.clientWidth - target.offsetWidth) / 2;
      try { strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); } catch (error) { strip.scrollLeft = Math.max(0, left); }
      strip.setAttribute('data-scpc-food-strip-centred', chosen);
    }
    if (!chosen) strip.removeAttribute('data-scpc-food-strip-centred');
  };

  /* ---- events (delegated on the section root) ---- */
  var scpcFoodBaseBind = Configurator.prototype.bind;
  Configurator.prototype.bind = function () {
    scpcFoodBaseBind.apply(this, arguments);
    var self = this;
    if (!this.foodRanges().length) return;

    this.listen(this.root, 'click', function (event) {
      var tab = closest(event.target, '[data-scpc-food-tab]', self.root);
      if (tab) {
        event.preventDefault();
        self._foodActiveTab = tab.getAttribute('data-scpc-food-tab');
        self.renderFood();
        try { tab.focus({ preventScroll: true }); } catch (error) { tab.focus(); }
        return;
      }
      var pickerTrigger = closest(event.target, '[data-scpc-food-picker-trigger]', self.root);
      if (pickerTrigger) {
        event.preventDefault();
        var triggerKey = pickerTrigger.getAttribute('data-scpc-food-picker-trigger');
        var pickerEl = self.foodPickerFor(triggerKey);
        if (pickerEl && pickerEl.classList.contains('is-open')) self.closeFoodPickers(null, true);
        else self.openFoodPicker(triggerKey);
        return;
      }
      var listRow = closest(event.target, '[data-scpc-food-list-product]', self.root);
      if (listRow) {
        event.preventDefault();
        if (listRow.getAttribute('aria-disabled') === 'true') return;
        var rowKey = listRow.getAttribute('data-scpc-food-key');
        self.closeFoodPickers(null, true);
        self.chooseFoodProduct(rowKey, integer(listRow.getAttribute('data-scpc-food-list-product'), 0), 'list');
        return;
      }
      if (!closest(event.target, '[data-scpc-food-picker]', self.root)) self.closeFoodPickers();

      var infoButton = closest(event.target, '[data-scpc-food-info]', self.root);
      if (infoButton) {
        event.preventDefault();
        event.stopPropagation();
        self.openFoodModal(infoButton.getAttribute('data-scpc-food-info'), infoButton);
        return;
      }
      var skipButton = closest(event.target, '[data-scpc-food-skip]', self.root);
      if (skipButton) {
        event.preventDefault();
        var stepKey = skipButton.getAttribute('data-scpc-food-skip');
        self.setFoodSkip(stepKey, !self.foodSkipped(stepKey));
        return;
      }
      var stripItem = closest(event.target, '[data-scpc-food-strip-product]', self.root);
      if (stripItem && !stripItem.disabled) {
        event.preventDefault();
        self.chooseFoodProduct(stripItem.getAttribute('data-scpc-food-key'), integer(stripItem.getAttribute('data-scpc-food-strip-product'), 0), 'strip');
        return;
      }
      var size = closest(event.target, '[data-scpc-food-variant]', self.root);
      if (size && !size.disabled) {
        event.preventDefault();
        self.chooseFoodVariant(size.getAttribute('data-scpc-food-key'), integer(size.getAttribute('data-scpc-food-variant'), 0));
        return;
      }
      var plus = closest(event.target, '[data-scpc-food-plus]', self.root);
      if (plus) { event.preventDefault(); self.changeFoodQty(plus.getAttribute('data-scpc-food-plus'), 1); return; }
      var minus = closest(event.target, '[data-scpc-food-minus]', self.root);
      if (minus) { event.preventDefault(); self.changeFoodQty(minus.getAttribute('data-scpc-food-minus'), -1); return; }
      var remove = closest(event.target, '[data-scpc-food-remove]', self.root);
      if (remove) {
        event.preventDefault();
        self.removeFoodLine(remove.getAttribute('data-scpc-food-remove'), remove.getAttribute('data-scpc-food-remove-variant'));
      }
    });

    this.listen(this.root, 'change', function (event) {
      var select = closest(event.target, '[data-scpc-food-product]', self.root);
      if (!select) return;
      self.chooseFoodProduct(select.getAttribute('data-scpc-food-product'), integer(select.value, 0), 'product');
    });

    // Picker keyboard: open/close, move highlight, select.
    this.listen(this.root, 'keydown', function (event) {
      var trigger = closest(event.target, '[data-scpc-food-picker-trigger]', self.root);
      if (trigger) {
        var tKey = trigger.getAttribute('data-scpc-food-picker-trigger');
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') { event.preventDefault(); self.openFoodPicker(tKey); }
        else if (event.key === 'Escape') { self.closeFoodPickers(null, true); }
        return;
      }
      var listEl = closest(event.target, '[data-scpc-food-list]', self.root);
      if (listEl) {
        var lKey = listEl.getAttribute('data-scpc-food-list');
        if (event.key === 'ArrowDown') { event.preventDefault(); self.moveFoodHighlight(lKey, 1); }
        else if (event.key === 'ArrowUp') { event.preventDefault(); self.moveFoodHighlight(lKey, -1); }
        else if (event.key === 'Home') { event.preventDefault(); self.moveFoodHighlight(lKey, -9999); }
        else if (event.key === 'End') { event.preventDefault(); self.moveFoodHighlight(lKey, 9999); }
        else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          var active = listEl.querySelector('[role="option"].is-active');
          if (active && active.getAttribute('aria-disabled') !== 'true') {
            self.closeFoodPickers(null, true);
            self.chooseFoodProduct(lKey, integer(active.getAttribute('data-scpc-food-list-product'), 0), 'list');
          }
        }
        else if (event.key === 'Escape') { event.preventDefault(); self.closeFoodPickers(null, true); }
        else if (event.key === 'Tab') { self.closeFoodPickers(); }
        return;
      }
      // Tabs: arrows move, Home/End jump.
      var tab = closest(event.target, '[data-scpc-food-tab]', self.root);
      if (!tab) return;
      var tabs = list(tab.parentNode.querySelectorAll('[data-scpc-food-tab]'));
      var index = tabs.indexOf(tab);
      var next = -1;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      if (next < 0) return;
      event.preventDefault();
      self._foodActiveTab = tabs[next].getAttribute('data-scpc-food-tab');
      self.renderFood();
      try { tabs[next].focus({ preventScroll: true }); } catch (error) { tabs[next].focus(); }
    });

    this.listen(document, 'click', function (event) {
      if (!self.root.contains(event.target)) self.closeFoodPickers();
    });

    this.initFoodPickers();
  };

  var scpcFoodBaseRender = Configurator.prototype.render;
  Configurator.prototype.render = function () {
    var result = scpcFoodBaseRender.apply(this, arguments);
    try { this.renderFood(); } catch (error) { if (window.console && console.error) console.error('[scpc food] render failed', error); }
    return result;
  };

  /* ================================================================
     EXTRAS VARIANT PICKER (v66)
     A quantity add-on with "Let the shopper choose the variant" carries
     item.variants. Choosing one re-points the item itself (variantId,
     price, compareAt, available, image); the base engine then prices,
     reviews and carts it with no further wiring. Labels in the review get
     the size appended by a resolve wrapper. Choice persists beside food.
     ================================================================ */
  var SCPC_QV_STORAGE_SUFFIX = ':qvariants';

  Configurator.prototype.qvItems = function () {
    return (this.config.quantities || []).filter(function (item) {
      return item.variantPicker && Array.isArray(item.variants) && item.variants.length > 1 && !item.pairVariantId;
    });
  };

  Configurator.prototype.qvState = function () {
    if (!this.state.quantityVariants || typeof this.state.quantityVariants !== 'object') this.state.quantityVariants = {};
    return this.state.quantityVariants;
  };

  Configurator.prototype.qvVariant = function (item, variantId) {
    return (item.variants || []).filter(function (v) { return text(v.id) === text(variantId); })[0] || null;
  };

  /* Re-point the item at a variant. Silent (no update) when called during init. */
  Configurator.prototype.qvApply = function (item, variantId, silent) {
    var variant = this.qvVariant(item, variantId);
    if (!variant) return false;
    if (item.qvBase === undefined) {
      item.qvBase = { variantId: item.variantId, price: item.price, compareAt: item.compareAt, available: item.available, label: item.label };
    }
    item.variantId = variant.id;
    item.price = cents(variant.price);
    item.compareAt = cents(variant.compareAt);
    item.available = !!variant.available;
    item.qvTitle = variant.title;
    item.qvImage = variant.image || '';
    this.qvState()[item.key] = variant.id;
    if (!silent) this.update('qvariant:' + item.key);
    return true;
  };

  /* Preselect: stored choice, else the block's own variant, else the first available. */
  Configurator.prototype.qvInit = function () {
    var self = this;
    var saved = {};
    if (this.config && this.config.persist && window.sessionStorage) {
      try { saved = JSON.parse(sessionStorage.getItem(this.storageKey() + SCPC_QV_STORAGE_SUFFIX) || '{}') || {}; } catch (error) { saved = {}; }
    }
    this.qvItems().forEach(function (item) {
      var chosen = self.qvVariant(item, saved[item.key]);
      if (chosen && !chosen.available) chosen = null;
      if (!chosen) { var own = self.qvVariant(item, item.variantId); chosen = own && own.available ? own : null; }
      if (!chosen) chosen = item.variants.filter(function (v) { return v.available; })[0] || item.variants[0];
      if (chosen) self.qvApply(item, chosen.id, true);
    });
  };

  var scpcQvBasePersist = Configurator.prototype.persist;
  Configurator.prototype.persist = function () {
    scpcQvBasePersist.apply(this, arguments);
    if (!this.config || !this.config.persist || !window.sessionStorage) return;
    try { sessionStorage.setItem(this.storageKey() + SCPC_QV_STORAGE_SUFFIX, JSON.stringify(this.qvState())); } catch (error) {}
  };

  // Init after the engine has restored its own state; before the first update.
  var scpcQvBaseRestore = Configurator.prototype.restore;
  Configurator.prototype.restore = function () {
    scpcQvBaseRestore.apply(this, arguments);
    try { this.qvInit(); } catch (error) { if (window.console && console.error) console.error('[scpc qvariants] init failed', error); }
  };

  /* Review labels carry the size. Runs after the food wrapper (defined later in the file = outermost). */
  var scpcQvBaseResolve = Configurator.prototype.resolve;
  Configurator.prototype.resolve = function (selections, quantities) {
    var solution = scpcQvBaseResolve.call(this, selections, quantities);
    try {
      var byVariant = {};
      this.qvItems().forEach(function (item) { if (item.qvTitle) byVariant[text(item.variantId)] = item; });
      (solution.lines || []).forEach(function (line) {
        var item = byVariant[text(line.id)];
        if (item && line.source === 'quantity' && line.label === item.label) line.label = item.label + ' · ' + item.qvTitle;
      });
    } catch (error) {}
    return solution;
  };

  /* DOM sync: pressed pill / selected option / card image. */
  Configurator.prototype.renderQvariants = function () {
    var self = this;
    this.qvItems().forEach(function (item) {
      var cards = list(self.root.querySelectorAll('[data-scpc-quantity="' + item.id + '"]'));
      cards.forEach(function (card) {
        var chosen = text(item.variantId);
        list(card.querySelectorAll('[data-scpc-qvariant]')).forEach(function (pill) {
          var on = pill.getAttribute('data-scpc-qvariant') === chosen;
          pill.setAttribute('aria-pressed', on ? 'true' : 'false');
          pill.classList.toggle('is-selected', on);
        });
        var select = card.querySelector('[data-scpc-qvariant-select]');
        if (select && select.value !== chosen) select.value = chosen;
        var img = card.querySelector('.scpc__quantity-media img');
        if (img) {
          if (!img.getAttribute('data-scpc-qv-original')) img.setAttribute('data-scpc-qv-original', img.getAttribute('src') || '');
          var want = item.qvImage || img.getAttribute('data-scpc-qv-original');
          if (want && img.getAttribute('src') !== want) { img.setAttribute('src', want); img.removeAttribute('srcset'); }
        }
      });
    });
  };

  var scpcQvBaseRender = Configurator.prototype.render;
  Configurator.prototype.render = function () {
    var result = scpcQvBaseRender.apply(this, arguments);
    try { this.renderQvariants(); } catch (error) {}
    return result;
  };

  var scpcQvBaseBind = Configurator.prototype.bind;
  Configurator.prototype.bind = function () {
    scpcQvBaseBind.apply(this, arguments);
    var self = this;
    if (!this.qvItems().length) return;
    this.listen(this.root, 'click', function (event) {
      var pill = closest(event.target, '[data-scpc-qvariant]', self.root);
      if (!pill || pill.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      var item = self.quantitiesById[pill.getAttribute('data-scpc-qvariant-key')];
      if (item && text(item.variantId) !== pill.getAttribute('data-scpc-qvariant')) self.qvApply(item, pill.getAttribute('data-scpc-qvariant'), false);
    }, true);
    this.listen(this.root, 'change', function (event) {
      var select = closest(event.target, '[data-scpc-qvariant-select]', self.root);
      if (!select) return;
      var item = self.quantitiesById[select.getAttribute('data-scpc-qvariant-select')];
      if (item) self.qvApply(item, select.value, false);
    });
  };

  /* ================================================================
     EMPTY STEPS (v67)
     Liquid flags a step "empty" when nothing in it can render for this
     market. Treat it exactly like a rule-hidden step: out of the accordion,
     the progress count, advanceFrom and the guide CTA.
     ================================================================ */
  var scpcEmptyBaseDeriveEffects = Configurator.prototype.deriveEffects;
  Configurator.prototype.deriveEffects = function (selections, quantities) {
    var effects = scpcEmptyBaseDeriveEffects.apply(this, arguments);
    try {
      (this.config.steps || []).forEach(function (step) {
        if (step && step.empty === true) effects.hiddenSteps[step.key] = true;
      });
    } catch (error) {}
    return effects;
  };

  /* ================================================================
     BUILDER ATTRIBUTION + ADD TRACKING (v75)
     Writes one cart attribute so every order is attributable to the
     builder in Shopify admin, and pushes one dataLayer event so GA4 can
     report builder usage. Nothing here is customer-visible.
     ================================================================ */

  /* Short, readable value for the order: the resolved bundle SKU, else 'custom'. */
  Configurator.prototype.buildAttributeValue = function () {
    var bundle = this.resolution && this.resolution.bundle;
    if (!bundle) return 'custom';
    if (bundle.sku) return text(bundle.sku);
    if (bundle.title) return text(bundle.title);
    if (bundle.variantId) return 'variant-' + text(bundle.variantId);
    return 'custom';
  };

  /* A compact readable summary of the choices, e.g. "large|easy-tray|birdie-bar".
     Kept under 100 characters so it fits a GA4 parameter value. */
  Configurator.prototype.buildSummary = function () {
    var self = this;
    var parts = [];
    (this.config.steps || []).forEach(function (step) {
      (self.optionsByStep[step.key] || []).forEach(function (option) {
        if (self.optionSelected(option, self.state.selections)) parts.push(option.value || option.label);
      });
    });
    return parts.join('|').slice(0, 100);
  };

  /* One cart attribute. Sent after the add so a failure here can never block it. */
  Configurator.prototype.stampBuildAttribute = function () {
    var base = (this.config && this.config.cartUrl) ? this.config.cartUrl : '/cart';
    var body = { attributes: { _sc_build: this.buildAttributeValue() } };
    fetch(base + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).catch(function () { /* attribution is best effort */ });
  };

  Configurator.prototype.trackBuildAdded = function () {
    var resolution = this.resolution || {};
    var lines = resolution.lines || [];
    var currency = '';
    try { currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active; } catch (error) { currency = ''; }

    var items = lines.map(function (line, index) {
      return {
        item_id: text(line.id),
        item_name: text(line.label),
        item_category: text(line.source),
        price: cents(line.price) / 100,
        quantity: integer(line.quantity, 1),
        index: index
      };
    });

    var foodLines = lines.filter(function (line) { return !!line.food; }).length;

    var payload = {
      event: 'sc_builder_add_to_cart',
      builder_key: (this.config && this.config.builderKey) || '',
      bundle_sku: this.buildAttributeValue(),
      bundle_signature: text(resolution.signature),
      build_summary: this.buildSummary(),
      build_total: cents(resolution.total) / 100,
      build_savings: cents(resolution.savings) / 100,
      line_count: lines.length,
      food_line_count: foodLines,
      viewed_3d: !!this._scpcViewed3d,
      currency: currency || 'AUD',
      items: items
    };

    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch (error) {}
    try { dispatch(this.root, 'sc-configurator:track', payload); } catch (error) {}
  };

  /* Did this shopper open the 3D viewer before adding? The viewer already
     dispatches sc-configurator:3d-open on the section root. */
  var scpcBaseBindV75 = Configurator.prototype.bind;
  Configurator.prototype.bind = function () {
    scpcBaseBindV75.apply(this, arguments);
    var self = this;
    this.listen(this.root, 'sc-configurator:3d-interact', function () { self._scpcViewed3d = true; });
  };

  function initAll(scope) { rootsIn(scope || document).forEach(init); }
  function destroyAll(scope) {
    rootsIn(scope || document).forEach(function (root) { if (root.__scpcInstance) root.__scpcInstance.destroy(); });
  }

  var API = {
    __engine: true,
    version: VERSION,
    init: init,
    initAll: initAll,
    destroyAll: destroyAll,
    get: function (root) { return root && root.__scpcInstance || null; },
    normalizeSignature: normalizeSignature
  };
  window.SCProductConfigurator = API;

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
}());
